// import { useState, useEffect } from 'react';
// import {
//     Box, Grid, TextField, Button, Typography, Select,
//     MenuItem, FormControl, InputLabel, Paper,
//     Alert, Snackbar, CircularProgress, Divider
// } from '@mui/material';
// import { GetApp } from '@mui/icons-material';
// import { useAuth } from '../context/AuthContext';
// import { useLocation } from "react-router-dom";
// import axios from "axios";

// /* ================= UTIL FUNCTIONS (UNCHANGED) ================= */
// const toTitleCase = (str = "") =>
//     str
//         .toLowerCase()
//         .split(" ")
//         .map(w => w.charAt(0).toUpperCase() + w.slice(1))
//         .join(" ");

// const formatDateToDDMMYYYY = (dateStr = "") => {
//     if (!dateStr) return "";
//     const [yyyy, mm, dd] = dateStr.split("-");
//     return `${dd}/${mm}/${yyyy}`;
// };

// const limitTo120Chars = (v = "") =>
//     String(v).length > 120 ? String(v).slice(0, 120) : String(v);

// const splitAddress120 = (address = "") => {
//     const str = String(address);
//     return {
//         addr1: str.slice(0, 120),
//         addr2: str.length > 120 ? str.slice(120, 240) : ""
//     };
// };

// /* ================= COMPONENT ================= */
// const EInvoiceMaster = ({ connectionString }) => {
//     const { selectedCompany } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     const location = useLocation();
//     const invoiceId = location.state?.invoiceId || null;
//     const bookName = location.state?.bookName || null;

//     const [formState, setFormState] = useState({
//         EWBUserName: '',
//         EWBPassword: '',
//         partyName: '',
//         billNo: '',
//         ewayBillNo: '',
//         subType: 'B2B',
//         docType: 'Tax Invoice',
//         transMode: 'Road',
//         vehicleType: 'Regular',
//         distance: '',
//         transType: 'Regular',
//         gstNo: '',
//     });

//     const [errors, setErrors] = useState({});
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [einvoiceData, setEinvoiceData] = useState(null);
//     const [einvoiceLoading, setEinvoiceLoading] = useState(false);
//     const [einvoiceSuccess, setEinvoiceSuccess] = useState(false);
//     const [einvoiceError, setEinvoiceError] = useState('');
//     const [submitError, setSubmitError] = useState('');
//     const [stateList, setStateList] = useState([]);
//     const [vehicleValidationErrors, setVehicleValidationErrors] = useState({});

//     /* ================= EFFECTS (UNCHANGED) ================= */
//     useEffect(() => {
//         if (!companyId) return;
//         axios.get(`${connectionString}/api/ewaybill/getCompanyUserNameandPassword`, {
//             params: { companyId, mode: "EI" }
//         }).then(res => {
//             if (res.data?.success) {
//                 setFormState(p => ({
//                     ...p,
//                     EIUserName: res.data.data.username,
//                     EIPassword: res.data.data.password,
//                     gstNo: res.data.data.gstNo
//                 }));
//             }
//         }).catch(err => {
//             console.error("Failed to fetch company credentials", err);
//         });
//     }, [companyId]);

//     useEffect(() => {
//         if (!invoiceId || !bookName) return;
//         fetchEinvoiceData(invoiceId, bookName);
//     }, [invoiceId, bookName]);

//     useEffect(() => {
//         if (!companyId) return;
//         axios.get(`${connectionString}/api/states`, { params: { companyId } })
//             .then(res => setStateList(res.data))
//             .catch(err => console.error("States fetch failed", err));
//     }, [companyId]);

//     const getTransTypeByPincode = (data) => {
//         const companyPin = String(data?.company?.pincode || "");
//         const shipFromPin = String(data?.consigner?.shipFrom?.pincode || "");
//         const clientPin = String(data?.client?.details?.pincode || "");
//         const shipToPin = String(data?.consigner?.shipTo?.pincode || "");

//         if (companyPin === shipFromPin && clientPin === shipToPin) {
//             return "Regular";
//         }
//         if (companyPin === shipFromPin && clientPin !== shipToPin) {
//             return "Bill To-Ship To";
//         }
//         if (companyPin !== shipFromPin && clientPin === shipToPin) {
//             return "Bill From-Disaptch From";
//         }
//         if (companyPin !== shipFromPin && companyPin !== clientPin && companyPin !== shipToPin && shipFromPin !== clientPin && shipFromPin !== shipToPin && clientPin !== shipToPin) {
//             return "Combination of 2 and 3";
//         }
//         return "Regular";
//     };

//     const fetchEinvoiceData = async (id, bookName) => {
//         try {
//             const endpoint =
//                 bookName === 'SALE'
//                     ? `${connectionString}/api/ewaybill/by-invoice/${id}`
//                     : bookName === 'CRNT'
//                         ? `${connectionString}/api/ewaybill/by-creditNote/${id}`
//                         : null;
//             const { data } = await axios.get(endpoint, { params: { companyId, bookName } });
//             setEinvoiceData(data);
//             console.log("data:", data);

//             const transporterName = data?.transporter?.transporterName || "";
//             const transporterGstNo = data?.transporter?.transporterGstNo || "";
//             const vehicleNo = data?.vehicleNo || "";

//             if (
//                 transporterName.toUpperCase() === "SELF" ||
//                 !transporterGstNo.trim()
//             ) {
//                 if (!vehicleNo.trim()) {
//                     setVehicleValidationErrors({
//                         vehicleNo: "Vehicle No is required when transporter is SELF or GST No is not provided"
//                     });

//                     setSnackbar({
//                         open: true,
//                         severity: "warning",
//                         message: "Vehicle No is required when transporter is SELF or GST No is not provided"
//                     });
//                 } else {
//                     setVehicleValidationErrors({});
//                 }
//             } else {
//                 setVehicleValidationErrors({});
//             }


//             setFormState(p => ({
//                 ...p,
//                 partyName: data?.client?.partyName || "",
//                 billNo: data?.client?.BillNumber || "",
//                 transType: getTransTypeByPincode(data),
//                 docType:
//                     bookName === "SALE"
//                         ? "Tax Invoice"
//                         : bookName === "SACH"
//                             ? "Delivery Challan"
//                             : p.docType,
//                 supplyType: bookName === "SALE" || bookName === "SACH"
//                     ? "Outward"
//                     : bookName === "CRNT"
//                         ? "Inward"
//                         : p.supplyType,
//                 subType: p.subType || "B2B",
//                 transMode: data?.transMode || p.transMode,
//                 vehicleType: data?.vehicleType || p.vehicleType,
//                 dispatchState: data?.client?.details?.State ? toTitleCase(data.client.details.State) : p.dispatchState,
//                 shipToState: data?.client?.details?.State ? toTitleCase(data.client.details.State) : p.shipToState,
//                 distance: data?.client?.details?.Distance || "",
//             }));
//         } catch {
//             setSnackbar({ open: true, message: "Failed to load invoice", severity: "error" });
//         }
//     };

//     /* ================= HELPERS ================= */
//     const handleChange = e => {
//         const { name, value } = e.target;
//         setFormState(p => ({ ...p, [name]: value }));
//         if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
//     };

//     const renderTextField = (label, name, required = false, multiline = false, disabled = false, type = 'text') => (
//         <TextField
//             fullWidth
//             label={label}
//             name={name}
//             value={formState[name] || ''}
//             onChange={handleChange}
//             error={!!errors[name]}
//             helperText={errors[name]}
//             required={required}
//             multiline={multiline}
//             minRows={multiline ? 4 : 1}
//             disabled={disabled}
//             type={type}
//             variant="outlined"
//             size="small"
//             sx={{
//                 '& .MuiOutlinedInput-root': { fontSize: '0.9rem' },
//                 '& .MuiInputLabel-root': { fontSize: '0.85rem' },
//             }}
//         />
//     );

//     const renderSelect = (label, name, options) => (
//         <FormControl fullWidth size="small">
//             <InputLabel sx={{ fontSize: '0.85rem' }}>{label}</InputLabel>
//             <Select
//                 name={name}
//                 value={formState[name] || options[0]}
//                 label={label}
//                 onChange={handleChange}
//             >
//                 {options.map(o => (
//                     <MenuItem key={o} value={o}>{o}</MenuItem>
//                 ))}
//             </Select>
//         </FormControl>
//     );

//     /* ================= OPTIONS ================= */
//     const subTypeOptions = ['B2B', 'SEZWP', 'SEZWOP', 'EXPWP', 'EXPWOP', 'DEXP'];
//     const docTypeOptions = ['Tax Invoice', 'Bill of Supply'];
//     const transModeOptions = ['Road', 'Rail', 'Air', 'Ship / Road cum Ship'];
//     const vehicleTypeOptions = ['Regular', 'ODC'];
//     const transTypeOptions = ['Regular', 'Bill To-Ship To', 'Bill From-Disaptch From', 'Combination of 2 and 3'];
//     const transModeMap = { Road: 1, Rail: 2, Air: 3, 'Ship / Road cum Ship': 4, };
//     const vehicleTypeMap = { Regular: 'R', ODC: 'O', };
//     const STATE_OPTIONS = stateList.map(s => toTitleCase(s.state));
//     const sellerAddress = splitAddress120(einvoiceData?.company?.address);
//     const buyerAddress = splitAddress120(einvoiceData?.client?.details?.address);
//     const DispDtlsAddress = splitAddress120(einvoiceData?.consigner?.shipFrom?.Address);
//     const ShipDtlsAddress = splitAddress120(einvoiceData?.consigner?.shipTo?.Address);

//     const getDocTypeCode = () => {
//         if (bookName === "SALE") return "INV"; // Tax Invoice
//         return undefined; // ⛔ no default value
//     };

//     /* ================= SUBMIT & DOWNLOAD (MODIFIED) ================= */
//     const handleSubmit = async () => {
//         setEinvoiceLoading(true);
//         setEinvoiceError('');
//         setSubmitError('');

//         const gstin = formState.gstNo;
//         const username = formState.EWBUserName;
//         const password = formState.EWBPassword;

//         try {
//             if (!einvoiceData) {
//                 throw new Error("Invoice data not loaded");
//             }

//             // STEP 1: AUTHORIZE - Get auth token
//             const authUrl = `http://192.168.1.248:5001/api/e-invoice/authorize?gstin=${encodeURIComponent(gstin)}&username=${encodeURIComponent(username)}&einvpwd=${encodeURIComponent(password)}`;
//             const authResponse = await axios.get(authUrl);

//             console.log(`>> authResponse : ${authResponse}`);

//             const authtoken = authResponse.data?.data?.authtoken || authResponse.data?.authtoken || authResponse.data?.token || (authResponse.data && typeof authResponse.data === 'string' ? authResponse.data : null);

//             console.log('authtoken: ',authtoken);

//             if (!authtoken) {
//                 setSnackbar({
//                 open: true,
//                 message: "Authorization failed. Token not received.",
//                 severity: "error"
//                 });
//                 setEinvoiceLoading(false);
//                 return;
//             }

//             /* ================= BUILD COMPLETE E-INVOICE JSON ================= */
//             const eInvoicePayload = {
//                 Version: "1.1",

//                 TranDtls: {
//                     TaxSch: "GST",
//                     SupTyp: formState.subType,
//                     EcmGstin: null,
//                     IgstOnIntra: "N"
//                 },

//                 DocDtls: {
//                     No: einvoiceData?.client?.BillNumber || "",
//                     Typ: getDocTypeCode(),
//                     Dt: String(formatDateToDDMMYYYY(einvoiceData?.client?.inquiryDate))
//                 },

//                 SellerDtls: {
//                     Gstin: formState.gstNo || "URP",
//                     LgINm: einvoiceData?.company?.companyName || "",
//                     TrdNm: null,
//                     Addr1: sellerAddress.addr1,
//                     Addr2: sellerAddress.addr2,
//                     Loc: einvoiceData?.company?.city,
//                     Pin: Number(einvoiceData?.company?.pincode),
//                     Stcd: String(einvoiceData?.company?.stateCode),
//                     Ph: Number(einvoiceData?.company?.mobileNo),
//                     Em: String(einvoiceData?.company?.email)
//                 },

//                 BuyerDtls: {
//                     Gstin: einvoiceData?.client?.details?.["GST No."] || "URP",
//                     LgINm: einvoiceData?.client?.partyName,
//                     TrdNm: null,
//                     Pos: String(einvoiceData?.client?.details?.stateCode),
//                     Addr1: buyerAddress.addr1,
//                     Addr2: buyerAddress.addr2,
//                     Loc: einvoiceData?.client?.details?.City,
//                     Pin: Number(einvoiceData?.client?.details?.pincode),
//                     Stcd: String(einvoiceData?.client?.details?.stateCode),
//                     Ph: Number(einvoiceData?.client?.details?.mobileNo),
//                     Em: String(einvoiceData?.client?.details?.Email),
//                 },

//                 DispDtls: {
//                     Nm: String(einvoiceData?.consigner?.shipFrom?.clientname || ""),
//                     Addr1: DispDtlsAddress.addr1,
//                     Addr2: DispDtlsAddress.addr2,
//                     Loc: String(einvoiceData?.consigner?.shipFrom?.City || ""),
//                     Pin: Number(einvoiceData?.consigner?.shipFrom?.pincode || ""),
//                     Stcd: Number(einvoiceData?.consigner?.shipFrom?.stateCode || "")
//                 },
//                 ShipDtls: {
//                     Gstin: String(einvoiceData?.consigner?.shipTo?.gstno || "URP"),
//                     LglNm: String(einvoiceData?.consigner?.shipTo?.clientname || ""),
//                     TrdNm: null,
//                     Addr1: ShipDtlsAddress.addr1,
//                     Addr2: ShipDtlsAddress.addr2,
//                     Loc: String(einvoiceData?.consigner?.shipTo?.City || ""),
//                     Pin: Number(einvoiceData?.consigner?.shipTo?.pincode || ""),
//                     Stcd: Number(einvoiceData?.consigner?.shipTo?.stateCode || "")
//                 },

//                 ItemList: einvoiceData?.product?.tableData?.length
//                     ? einvoiceData.product.tableData.map((item, index) => ({
//                         SINo: String(index + 1),
//                         PrdDesc: item.description,
//                         IsServc: String(item.hsnCode || "").startsWith("99") ? "Y" : "N",
//                         HsnCd: item.hsnCode || "",
//                         Qty: Number(item.qty),
//                         Unit: item.unit,
//                         UnitPrice: Number(item.rate),
//                         TotAmt: Number(item.qty) * Number(item.rate),
//                         Discount: Number(item.disc) || 0,
//                         PreTaxVal: 0,
//                         AssAmt: Number(item.taxableAmt),
//                         GstRt: Number(item.GSTPercent) || 0,
//                         IgstAmt: Number(item.IGSTAmt) || 0,
//                         CgstAmt: Number(item.CGSTAmt) || 0,
//                         SgstAmt: Number(item.SGSTAmt) || 0,
//                         CesRt: 0,
//                         CesAmt: 0,
//                         CesNonAdvlAmt: 0,
//                         StateCesRt: 0,
//                         StateCesAmt: 0,
//                         StateCesNonAdvlAmt: 0,
//                         OthChrg: 0,
//                         TotItemVal: Number(item.amount)
//                     }))
//                     : null,

//                 ValDtls: {
//                     AssVal: einvoiceData?.product?.summary?.taxableValue,
//                     IgstVal: einvoiceData?.product?.summary?.igst || 0,
//                     CgstVal: einvoiceData?.product?.summary?.cgst || 0,
//                     SgstVal: einvoiceData?.product?.summary?.sgst || 0,
//                     CesVal: 0,
//                     StCesVal: 0,
//                     Discount: 0,
//                     OthChrg: 0,
//                     RndOffAmt: einvoiceData?.product?.summary?.roundOff || 0,
//                     TotInvVal: einvoiceData?.product?.summary?.invoiceValue || 0,
//                     TotInvValFc: 0
//                 },

//                 ExpDtls: {
//                     ShipBNo: null,
//                     ShipBDt: null,
//                     Port: null,
//                     RefClm: null,
//                     ForCur: null,
//                     CntCode: null,
//                     ExpDuty: 0
//                 },
//                 PayDtls: null,

//                 EwbDtls: {
//                     TransId: einvoiceData?.transporter?.transporterGstNo || "URP",
//                     TransName: einvoiceData?.transporter?.transporterName || "",
//                     TransMode: transModeMap[formState.transMode],
//                     Distance: Number(formState.distance) || 0,
//                     TransDocNo: null,
//                     TransDocDt: formatDateToDDMMYYYY(einvoiceData?.client?.BillDate),  // <--
//                     VehNo: String(einvoiceData?.vehicleNo || "") || null,
//                     VehType: String(vehicleTypeMap[formState.vehicleType])
//                 }
//             };

//             /* ================= API CALL ================= */
//             // const res = await axios.post(
//             //     `${connectionString}/api/einvoice/generate`,
//             //     eInvoicePayload
//             // );

//             /* ================= SUCCESS ================= */
//             /* ================= PRINT JSON IN CONSOLE ================= */
//             console.log("========== E-INVOICE JSON ==========");
//             console.log(eInvoicePayload);
//             console.log("===================================");

//             /* ================= SUCCESS (SIMULATED) ================= */
//             setFormState(p => ({
//                 ...p,
//                 ewayBillNo: JSON.stringify(eInvoicePayload, null, 2)
//             }));

//             setEinvoiceSuccess(true);
//             setSnackbar({
//                 open: true,
//                 message: "E-Invoice generated successfully",
//                 severity: "success"
//             });

//         } catch (e) {
//             const msg = e?.response?.data?.message || e.message || "E-Invoice failed";
//             setEinvoiceError(msg);
//             setSnackbar({ open: true, message: msg, severity: "error" });
//         } finally {
//             setEinvoiceLoading(false);
//         }
//     };


//     const handleDownload = () => {
//         if (!formState.ewayBillNo?.trim()) {
//             setSnackbar({ open: true, message: 'No E-Invoice to download', severity: 'warning' });
//             return;
//         }
//         setSnackbar({ open: true, message: "Download started", severity: "success" });
//     };

//     /* ================= UI – REDESIGNED TO MATCH STYLE ================= */
//     return (
//         <Box sx={{ bgcolor: 'white', minHeight: '100vh', p: 1.5, fontFamily: 'Arial, sans-serif' }}>
//             <Paper
//                 elevation={0}
//                 sx={{
//                     border: '1px solid #ccc',
//                     maxWidth: 1200,
//                     mx: 'auto',
//                     overflow: 'hidden',
//                     bgcolor: '#fffef5',
//                 }}
//             >
//                 {/* Header – matched style */}
//                 <Box sx={{ bgcolor: '#fffacd', p: 1.5, borderBottom: '2px solid #d4a574', textAlign: 'center' }}>
//                     <Typography variant="h6" fontWeight="bold" color="#000">
//                         E-INVOICE BILL SYSTEM
//                     </Typography>
//                 </Box>

//                 <Box sx={{ p: 2 }}>
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                         <Box sx={{ maxWidth: 1100, mx: 'auto', px: 2, py: 1 }}>
//                             {/* Username & Password at top */}
//                             <Grid container spacing={1.5} justifyContent="center">
//                                 <Grid item xs={12} sm={6}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             E-Invoice Username
//                                         </Typography>
//                                         {renderTextField('', 'EIUserName', true, false, true)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             E-Invoice Password
//                                         </Typography>
//                                         {renderTextField('', 'EIPassword', true, false, true, 'password')}
//                                     </Box>
//                                 </Grid>
//                             </Grid>

//                             <Divider sx={{ my: 2.5 }} />

//                             {/* Row 1 */}
//                             <Grid container spacing={1.5} justifyContent="center">
//                                 <Grid item xs={12} sm={4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Party Name
//                                         </Typography>
//                                         {renderTextField('', 'partyName', true, false, true)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Bill No
//                                         </Typography>
//                                         {renderTextField('', 'billNo', true, false, true)}
//                                     </Box>
//                                 </Grid>
//                             </Grid>

//                             {/* Row 2 */}
//                             <Grid container spacing={1.5} justifyContent="center" sx={{ mt: 2 }}>
//                                 <Grid item xs={12} sm={3}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Sub Type
//                                         </Typography>
//                                         {renderSelect('', 'subType', subTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={3}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Doc Type
//                                         </Typography>
//                                         {renderSelect('', 'docType', docTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={3}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Trans Mode
//                                         </Typography>
//                                         {renderSelect('', 'transMode', transModeOptions)}
//                                     </Box>
//                                 </Grid>
//                             </Grid>

//                             {/* Row 3 */}
//                             <Grid container spacing={1.5} justifyContent="center" sx={{ mt: 2 }}>
//                                 <Grid item xs={12} sm={6} md={2.4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Vehicle Type
//                                         </Typography>
//                                         {renderSelect('', 'vehicleType', vehicleTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={2.4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Distance (Km)
//                                         </Typography>
//                                         {renderTextField('', 'distance')}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={2.4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             TransType
//                                         </Typography>
//                                         {renderSelect('', 'transType', transTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                             </Grid>
//                         </Box>

//                         <Box sx={{ mt: 2.5 }}>
//                             <Divider sx={{ mb: 2 }} />

//                             <Typography variant="subtitle2" sx={{ fontSize: '0.9rem', mb: 1, fontWeight: 600 }}>
//                                 E-Invoice Bill Response / Number
//                             </Typography>

//                             <Box sx={{ position: 'relative', mb: 2 }}>
//                                 {renderTextField(
//                                     einvoiceError ? `Error: ${einvoiceError}` : 'E-Invoice Response',
//                                     'ewayBillNo',
//                                     false,
//                                     true,
//                                     true
//                                 )}
//                                 {einvoiceError && (
//                                     <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
//                                         {einvoiceError}
//                                     </Typography>
//                                 )}
//                             </Box>

//                             {/* Action Buttons – matched placement & style */}
//                             <Box
//                                 sx={{
//                                     mt: 2.5,
//                                     display: 'flex',
//                                     flexWrap: 'wrap',
//                                     gap: 1.5,
//                                     justifyContent: 'center',
//                                 }}
//                             >
//                                 <Button
//                                     variant="contained"
//                                     color="primary"
//                                     size="small"
//                                     onClick={handleSubmit}
//                                     disabled={einvoiceLoading || Object.keys(vehicleValidationErrors).length > 0}
//                                     sx={{ minWidth: 140 }}
//                                 >
//                                     {einvoiceLoading ? (
//                                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                             <CircularProgress size={16} color="inherit" />
//                                             Generating...
//                                         </Box>
//                                     ) : (
//                                         'Generate E-Invoice'
//                                     )}
//                                 </Button>

//                                 {einvoiceSuccess && formState.ewayBillNo && (
//                                     <Button
//                                         variant="contained"
//                                         color="success"
//                                         size="small"
//                                         startIcon={<GetApp />}
//                                         onClick={handleDownload}
//                                         sx={{ minWidth: 160 }}
//                                     >
//                                         Open / Download
//                                     </Button>
//                                 )}
//                             </Box>
//                         </Box>
//                     </Box>
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={4000}
//                 onClose={() => setSnackbar(p => ({ ...p, open: false }))}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
//             >
//                 <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             {submitError && (
//                 <Alert severity="error" sx={{ mt: 1.5, maxWidth: 1200, mx: 'auto' }}>
//                     {submitError}
//                 </Alert>
//             )}
//         </Box>
//     );
// };

// export default EInvoiceMaster;



// import { useState, useEffect } from 'react';
// import {
//     Box, Grid, TextField, Button, Typography, Select,
//     MenuItem, FormControl, InputLabel, Paper,
//     Alert, Snackbar, CircularProgress, Divider
// } from '@mui/material';
// import QRCode from 'qrcode.react';
// import { GetApp } from '@mui/icons-material';
// import { useAuth } from '../context/AuthContext';
// import { useLocation } from "react-router-dom";
// import axios from "axios";

// /* ================= UTIL FUNCTIONS (UNCHANGED) ================= */
// const toTitleCase = (str = "") =>
//     str
//         .toLowerCase()
//         .split(" ")
//         .map(w => w.charAt(0).toUpperCase() + w.slice(1))
//         .join(" ");

// const formatDateToDDMMYYYY = (dateStr = "") => {
//     if (!dateStr) return "";
//     const [yyyy, mm, dd] = dateStr.split("-");
//     return `${dd}/${mm}/${yyyy}`;
// };

// const formatDateTimeToMySQLFormat = (dateStr = "") => {
//     if (!dateStr) return "";
//     // Handle ISO format (2024-02-24T14:35:22Z)
//     if (dateStr.includes("T")) {
//         return dateStr.replace("T", " ").split(".")[0];
//     }
//     // Handle DD/MM/YYYY format
//     const [dd, mm, yyyy] = dateStr.split("/");
//     return `${yyyy}-${mm}-${dd}`;
// };

// const limitTo120Chars = (v = "") =>
//     String(v).length > 120 ? String(v).slice(0, 120) : String(v);

// const splitAddress120 = (address = "") => {
//     const str = String(address);
//     return {
//         addr1: str.slice(0, 120),
//         addr2: str.length > 120 ? str.slice(120, 240) : ""
//     };
// };

// /* ================= COMPONENT ================= */
// const EInvoiceMaster = ({ connectionString, invoiceId, bookName }) => {
//     const { user, selectedCompany } = useAuth();
//     const companyId = selectedCompany?.CompId || null;
//     // const location = useLocation();
//     // const invoiceId = location.state?.invoiceId || null;
//     // const bookName = location.state?.bookName || null;

//     const [formState, setFormState] = useState({
//         EIUserName: '',
//         EIPassword: '',
//         partyName: '',
//         billNo: '',
//         einvoiceNo: '',
//         subType: 'B2B',
//         docType: 'Tax Invoice',
//         transMode: 'Road',
//         vehicleType: 'Regular',
//         distance: '',
//         transType: 'Regular',
//         gstNo: '',
//     });

//     const [errors, setErrors] = useState({});
//     const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
//     const [einvoiceData, setEinvoiceData] = useState(null);
//     const [einvoiceLoading, setEinvoiceLoading] = useState(false);
//     const [einvoiceSuccess, setEinvoiceSuccess] = useState(false);
//     const [einvoiceError, setEinvoiceError] = useState('');
//     const [submitError, setSubmitError] = useState('');
//     const [stateList, setStateList] = useState([]);
//     const [vehicleValidationErrors, setVehicleValidationErrors] = useState({});
//     const [einvoiceResponse, setEinvoiceResponse] = useState(null);
//     // for QR code:
//     const [qrCodeData, setQrCodeData] = useState(null);

//     /* ================= EFFECTS (UNCHANGED) ================= */
//     useEffect(() => {
//         if (!companyId) return;
//         axios.get(`${connectionString}/api/ewaybill/getCompanyUserNameandPassword`, {
//             params: { companyId, mode: "EI" }
//         }).then(res => {
//             if (res.data?.success) {
//                 setFormState(p => ({
//                     ...p,
//                     EIUserName: res.data.data.username,
//                     EIPassword: res.data.data.password,
//                     gstNo: res.data.data.gstNo
//                 }));
//             }
//         }).catch(err => {
//             console.error("Failed to fetch company credentials", err);
//         });
//     }, [companyId]);

//     useEffect(() => {
//         if (!invoiceId || !bookName) return;
//         fetchEinvoiceData(invoiceId, bookName);
//     }, [invoiceId, bookName]);

//     useEffect(() => {
//         if (!companyId) return;
//         axios.get(`${connectionString}/api/states`, { params: { companyId } })
//             .then(res => setStateList(res.data))
//             .catch(err => console.error("States fetch failed", err));
//     }, [companyId]);

//     const getTransTypeByPincode = (data) => {
//         const companyPin = String(data?.company?.pincode || "");
//         const shipFromPin = String(data?.consigner?.shipFrom?.pincode || "");
//         const clientPin = String(data?.client?.details?.pincode || "");
//         const shipToPin = String(data?.consigner?.shipTo?.pincode || "");

//         if (companyPin === shipFromPin && clientPin === shipToPin) {
//             return "Regular";
//         }
//         if (companyPin === shipFromPin && clientPin !== shipToPin) {
//             return "Bill To-Ship To";
//         }
//         if (companyPin !== shipFromPin && clientPin === shipToPin) {
//             return "Bill From-Disaptch From";
//         }
//         if (companyPin !== shipFromPin && companyPin !== clientPin && companyPin !== shipToPin && shipFromPin !== clientPin && shipFromPin !== shipToPin && clientPin !== shipToPin) {
//             return "Combination of 2 and 3";
//         }
//         return "Regular";
//     };

//     const fetchEinvoiceData = async (id, bookName) => {
//         try {
//             const endpoint =
//                 bookName === 'SALE'
//                     ? `${connectionString}/api/ewaybill/by-invoice/${id}`
//                     : bookName === 'CRNT'
//                         ? `${connectionString}/api/ewaybill/by-creditNote/${id}`
//                         : null;
//             const { data } = await axios.get(endpoint, { params: { companyId, bookName } });
//             setEinvoiceData(data);
//             console.log("data:", data);

//             const transporterName = data?.transporter?.transporterName || "";
//             const transporterGstNo = data?.transporter?.transporterGstNo || "";
//             const vehicleNo = data?.vehicleNo || "";

//             if (
//                 transporterName.toUpperCase() === "SELF" ||
//                 !transporterGstNo.trim()
//             ) {
//                 if (!vehicleNo.trim()) {
//                     setVehicleValidationErrors({
//                         vehicleNo: "Vehicle No is required when transporter is SELF or GST No is not provided"
//                     });

//                     setSnackbar({
//                         open: true,
//                         severity: "warning",
//                         message: "Vehicle No is required when transporter is SELF or GST No is not provided"
//                     });
//                 } else {
//                     setVehicleValidationErrors({});
//                 }
//             } else {
//                 setVehicleValidationErrors({});
//             }


//             setFormState(p => ({
//                 ...p,
//                 partyName: data?.client?.partyName || "",
//                 billNo: data?.client?.BillNumber || "",
//                 transType: getTransTypeByPincode(data),
//                 docType:
//                     bookName === "SALE"
//                         ? "Tax Invoice"
//                         : bookName === "SACH"
//                             ? "Delivery Challan"
//                             : p.docType,
//                 supplyType: bookName === "SALE" || bookName === "SACH"
//                     ? "Outward"
//                     : bookName === "CRNT"
//                         ? "Inward"
//                         : p.supplyType,
//                 subType: p.subType || "B2B",
//                 transMode: data?.transMode || p.transMode,
//                 vehicleType: data?.vehicleType || p.vehicleType,
//                 dispatchState: data?.client?.details?.State ? toTitleCase(data.client.details.State) : p.dispatchState,
//                 shipToState: data?.client?.details?.State ? toTitleCase(data.client.details.State) : p.shipToState,
//                 distance: data?.client?.details?.Distance || "",
//             }));
//         } catch {
//             setSnackbar({ open: true, message: "Failed to load invoice", severity: "error" });
//         }
//     };

//     /* ================= HELPERS ================= */
//     const handleChange = e => {
//         const { name, value } = e.target;
//         setFormState(p => ({ ...p, [name]: value }));
//         if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
//     };

//     const renderTextField = (label, name, required = false, multiline = false, disabled = false, type = 'text') => (
//         <TextField
//             fullWidth
//             label={label}
//             name={name}
//             value={formState[name] || ''}
//             onChange={handleChange}
//             error={!!errors[name]}
//             helperText={errors[name]}
//             required={required}
//             multiline={multiline}
//             minRows={multiline ? 4 : 1}
//             disabled={disabled}
//             type={type}
//             variant="outlined"
//             size="small"
//             sx={{
//                 '& .MuiOutlinedInput-root': { fontSize: '0.9rem' },
//                 '& .MuiInputLabel-root': { fontSize: '0.85rem' },
//             }}
//         />
//     );

//     const renderSelect = (label, name, options) => (
//         <FormControl fullWidth size="small">
//             <InputLabel sx={{ fontSize: '0.85rem' }}>{label}</InputLabel>
//             <Select
//                 name={name}
//                 value={formState[name] || options[0]}
//                 label={label}
//                 onChange={handleChange}
//             >
//                 {options.map(o => (
//                     <MenuItem key={o} value={o}>{o}</MenuItem>
//                 ))}
//             </Select>
//         </FormControl>
//     );

//     /* ================= OPTIONS ================= */
//     const subTypeOptions = ['B2B', 'SEZWP', 'SEZWOP', 'EXPWP', 'EXPWOP', 'DEXP'];
//     const docTypeOptions = ['Tax Invoice', 'Bill of Supply'];
//     const transModeOptions = ['Road', 'Rail', 'Air', 'Ship / Road cum Ship'];
//     const vehicleTypeOptions = ['Regular', 'ODC'];
//     const transTypeOptions = ['Regular', 'Bill To-Ship To', 'Bill From-Disaptch From', 'Combination of 2 and 3'];
//     const transModeMap = { Road: 1, Rail: 2, Air: 3, 'Ship / Road cum Ship': 4, };
//     const vehicleTypeMap = { Regular: 'R', ODC: 'O', };
//     const STATE_OPTIONS = stateList.map(s => toTitleCase(s.state));
//     const sellerAddress = splitAddress120(einvoiceData?.company?.address);
//     const buyerAddress = splitAddress120(einvoiceData?.client?.details?.address);
//     const DispDtlsAddress = splitAddress120(einvoiceData?.consigner?.shipFrom?.Address);
//     const ShipDtlsAddress = splitAddress120(einvoiceData?.consigner?.shipTo?.Address);

//     const getDocTypeCode = () => {
//         if (bookName === "SALE") return "INV"; // Tax Invoice
//         return undefined; // ⛔ no default value
//     };

//     /* ================= STORE E-INVOICE IN DATABASE ================= */
//     const storeEinvoiceInDatabase = async (responseData) => {
//         try {
//             // Extract required fields from response
//             const irnNo = responseData?.data?.irn || "";
//             const invQRDetails = responseData?.data?.signedQRCode || "";
//             const ackNo = responseData?.data?.ackNo || "";
//             const ackDt = responseData?.data?.ackDt || "";

//             // Convert ACK date to MySQL format if needed

//             const storagePayload = {
//                 companyId,
//                 bookName,
//                 invoiceId,
//                 userId: user?.UserId,
//                 branchId: user?.BranchId || "",
//                 fYear: user?.FYear || "",
//                 mode: "EINVOICE",
//                 IRNNo: irnNo,
//                 INVQRDetails: invQRDetails,
//                 ACKNo: ackNo,
//                 ACKDate: ackDt
//             };

//             console.log("Storing E-Invoice with payload:", storagePayload);

//             const storeResponse = await axios.post(
//                 `${connectionString}/api/store-einvoice`,
//                 storagePayload
//             );

//             if (storeResponse.data?.success) {
//                 setSnackbar({
//                     open: true,
//                     message: storeResponse.data?.message || "E-Invoice stored successfully",
//                     severity: "success"
//                 });
//                 return true;
//             } else {
//                 throw new Error(storeResponse.data?.message || "Failed to store E-Invoice");
//             }
//         } catch (error) {
//             console.error("Store E-Invoice Error:", error);
//             setSnackbar({
//                 open: true,
//                 message: error?.response?.data?.message || error.message || "Failed to store E-Invoice",
//                 severity: "error"
//             });
//             return false;
//         }
//     };

//     useEffect(() => {
//         if (!invoiceId || !bookName || !companyId) return;

//         checkEinvoiceExists();
//     }, [invoiceId, bookName, companyId]);

//     const checkEinvoiceExists = async () => {
//         try {
//             if (!companyId || !bookName || !invoiceId) return;

//             const response = await axios.get(
//                 `${connectionString}/api/check-einvoice-exists`,
//                 {
//                     params: {
//                         companyId,
//                         bookName,
//                         invoiceId
//                     }
//                 }
//             );

//             if (response.data?.success && response.data?.exists) {

//                 const data = response.data.data;

//                 const irnNo = data?.IRNNo || "";
//                 const qrBase64 = data?.INVQRDetails || "";
//                 const ackNo = data?.ACKNo || "";
//                 const ackDt = data?.ACKDate || "";

//                 setQrCodeData(irnNo);

//                 // ✅ Print in console
//                 console.log("=== E-INVOICE ALREADY EXISTS ===");
//                 // In handleSubmit, after generateResponse, add:
//                 // console.log("IRN No:", data);
//                 console.log("IRN No:", irnNo);
//                 console.log("ACK No:", ackNo);
//                 console.log("ACK Date:", ackDt);
//                 console.log("INVQRDetails (Base64):", qrBase64);
//                 console.log("================================");

//                 // ✅ Set IRN in form
//                 setFormState(prev => ({
//                     ...prev,
//                     einvoiceNo: irnNo
//                 }));

//                 // ✅ Store QR response in same format as generate API
//                 setEinvoiceResponse({
//                     data: {
//                         irn: irnNo,
//                         signedQRCode: qrBase64,
//                         ackNo: ackNo,
//                         ackDt: ackDt
//                     }
//                 });

//                 // ✅ Disable Generate Button
//                 setEinvoiceSuccess(true);

//                 setSnackbar({
//                     open: true,
//                     message: "E-Invoice already exists for this document",
//                     severity: "info"
//                 });

//             } else {
//                 console.log("No existing E-Invoice found.");
//                 setEinvoiceSuccess(false);
//             }

//         } catch (error) {
//             console.error("Error checking E-Invoice existence:", error);
//             setSnackbar({
//                 open: true,
//                 message: "Failed to check E-Invoice existence",
//                 severity: "error"
//             });
//         }
//     };

//     /* ================= SUBMIT & DOWNLOAD (MODIFIED) ================= */
//     const handleSubmit = async () => {
//         setEinvoiceLoading(true);
//         setEinvoiceError('');
//         setSubmitError('');
//         setEinvoiceSuccess(false);

//         const gstin = formState.gstNo;
//         const username = formState.EIUserName;
//         const password = formState.EIPassword;

//         try {
//             if (!einvoiceData) {
//                 throw new Error("Invoice data not loaded");
//             }

//             // STEP 1: AUTHORIZE - Get auth token
//             const authUrl = `http://192.168.1.248:5001/api/e-invoice/authorize?gstin=${encodeURIComponent(gstin)}&username=${encodeURIComponent(username)}&einvpwd=${encodeURIComponent(password)}`;
//             const authResponse = await axios.get(authUrl);

//             console.log(`>> authResponse : ${authResponse}`);

//             const authtoken = authResponse.data?.data?.authtoken || authResponse.data?.authtoken || authResponse.data?.token || (authResponse.data && typeof authResponse.data === 'string' ? authResponse.data : null);

//             console.log('authtoken: ', authtoken);

//             if (!authtoken) {
//                 setSnackbar({
//                     open: true,
//                     message: "Authorization failed. Token not received.",
//                     severity: "error"
//                 });
//                 setEinvoiceLoading(false);
//                 return;
//             }

//             /* ================= BUILD COMPLETE E-INVOICE JSON ================= */
//             const eInvoicePayload = {
//                 Version: "1.1",

//                 TranDtls: {
//                     TaxSch: "GST",
//                     SupTyp: formState.subType,
//                     EcmGstin: null,
//                     IgstOnIntra: "N"
//                 },

//                 DocDtls: {
//                     No: einvoiceData?.client?.BillNumber || "",
//                     Typ: getDocTypeCode(),
//                     Dt: String(formatDateToDDMMYYYY(einvoiceData?.client?.inquiryDate))
//                 },

//                 SellerDtls: {
//                     Gstin: formState.gstNo || "URP",
//                     LgINm: einvoiceData?.company?.companyName || "",
//                     TrdNm: null,
//                     Addr1: sellerAddress.addr1,
//                     Addr2: sellerAddress.addr2,
//                     Loc: einvoiceData?.company?.city,
//                     Pin: Number(einvoiceData?.company?.pincode),
//                     Stcd: String(einvoiceData?.company?.stateCode),
//                     Ph: Number(einvoiceData?.company?.mobileNo),
//                     Em: String(einvoiceData?.company?.email)
//                 },

//                 BuyerDtls: {
//                     Gstin: einvoiceData?.client?.details?.["GST No."] || "URP",
//                     LgINm: einvoiceData?.client?.partyName,
//                     TrdNm: null,
//                     Pos: String(einvoiceData?.client?.details?.stateCode),
//                     Addr1: buyerAddress.addr1,
//                     Addr2: buyerAddress.addr2,
//                     Loc: einvoiceData?.client?.details?.City,
//                     Pin: Number(einvoiceData?.client?.details?.pincode),
//                     Stcd: String(einvoiceData?.client?.details?.stateCode),
//                     Ph: Number(einvoiceData?.client?.details?.mobileNo),
//                     Em: String(einvoiceData?.client?.details?.Email),
//                 },

//                 DispDtls: {
//                     Nm: String(einvoiceData?.consigner?.shipFrom?.clientname || ""),
//                     Addr1: DispDtlsAddress.addr1,
//                     Addr2: DispDtlsAddress.addr2,
//                     Loc: String(einvoiceData?.consigner?.shipFrom?.City || ""),
//                     Pin: Number(einvoiceData?.consigner?.shipFrom?.pincode || ""),
//                     Stcd: Number(einvoiceData?.consigner?.shipFrom?.stateCode || "")
//                 },
//                 ShipDtls: {
//                     Gstin: String(einvoiceData?.consigner?.shipTo?.gstno || "URP"),
//                     LglNm: String(einvoiceData?.consigner?.shipTo?.clientname || ""),
//                     TrdNm: null,
//                     Addr1: ShipDtlsAddress.addr1,
//                     Addr2: ShipDtlsAddress.addr2,
//                     Loc: String(einvoiceData?.consigner?.shipTo?.City || ""),
//                     Pin: Number(einvoiceData?.consigner?.shipTo?.pincode || ""),
//                     Stcd: Number(einvoiceData?.consigner?.shipTo?.stateCode || "")
//                 },

//                 ItemList: einvoiceData?.product?.tableData?.length
//                     ? einvoiceData.product.tableData.map((item, index) => ({
//                         SINo: String(index + 1),
//                         PrdDesc: item.description,
//                         IsServc: String(item.hsnCode || "").startsWith("99") ? "Y" : "N",
//                         HsnCd: item.hsnCode || "",
//                         Qty: Number(item.qty),
//                         Unit: item.unit,
//                         UnitPrice: Number(item.rate),
//                         TotAmt: Number(item.qty) * Number(item.rate),
//                         Discount: Number(item.disc) || 0,
//                         PreTaxVal: 0,
//                         AssAmt: Number(item.taxableAmt),
//                         GstRt: Number(item.GSTPercent) || 0,
//                         IgstAmt: Number(item.IGSTAmt) || 0,
//                         CgstAmt: Number(item.CGSTAmt) || 0,
//                         SgstAmt: Number(item.SGSTAmt) || 0,
//                         CesRt: 0,
//                         CesAmt: 0,
//                         CesNonAdvlAmt: 0,
//                         StateCesRt: 0,
//                         StateCesAmt: 0,
//                         StateCesNonAdvlAmt: 0,
//                         OthChrg: 0,
//                         TotItemVal: Number(item.amount)
//                     }))
//                     : null,

//                 ValDtls: {
//                     AssVal: einvoiceData?.product?.summary?.taxableValue,
//                     IgstVal: einvoiceData?.product?.summary?.igst || 0,
//                     CgstVal: einvoiceData?.product?.summary?.cgst || 0,
//                     SgstVal: einvoiceData?.product?.summary?.sgst || 0,
//                     CesVal: 0,
//                     StCesVal: 0,
//                     Discount: 0,
//                     OthChrg: 0,
//                     RndOffAmt: einvoiceData?.product?.summary?.roundOff || 0,
//                     TotInvVal: einvoiceData?.product?.summary?.invoiceValue || 0,
//                     TotInvValFc: 0
//                 },

//                 ExpDtls: {
//                     ShipBNo: null,
//                     ShipBDt: null,
//                     Port: null,
//                     RefClm: null,
//                     ForCur: null,
//                     CntCode: null,
//                     ExpDuty: 0
//                 },
//                 PayDtls: null,

//                 EwbDtls: {
//                     TransId: einvoiceData?.transporter?.transporterGstNo || "URP",
//                     TransName: einvoiceData?.transporter?.transporterName || "",
//                     TransMode: transModeMap[formState.transMode],
//                     Distance: Number(formState.distance) || 0,
//                     TransDocNo: null,
//                     TransDocDt: formatDateToDDMMYYYY(einvoiceData?.client?.BillDate),
//                     VehNo: String(einvoiceData?.vehicleNo || "") || null,
//                     VehType: String(vehicleTypeMap[formState.vehicleType])
//                 }
//             };

//             /* ================= API CALL TO GENERATE E-INVOICE ================= */
//             const generateResponse = await axios.post(
//                 'http://192.168.1.248:5001/api/e-invoice/generate-with-auth',
//                 eInvoicePayload,
//                 {
//                     params: {
//                         username: formState.EIUserName,
//                         einvpwd: formState.EIPassword,
//                         gstin: formState.gstNo
//                     }
//                 }
//             );

//             console.log("E-Invoice Generate Response:", generateResponse.data);

//             /* ================= CHECK IF STATUS IS SUCCESS ================= */
//             if (generateResponse.data?.status === "success" && generateResponse.data?.data) {

//                 // Store the response details
//                 setEinvoiceResponse(generateResponse.data);

//                 // Store in database
//                 const stored = await storeEinvoiceInDatabase(generateResponse.data);

//                 if (stored) {
//                     // Set form state with IRN for display
//                     setFormState(p => ({
//                         ...p,
//                         einvoiceNo: generateResponse.data?.data?.irn || ""
//                     }));

//                     // ✅ UPDATE MASTER TABLES (NEW)
//                     // await updateEinvoiceInMasterTables(generateResponse.data);

//                     setEinvoiceSuccess(true);
//                     setSnackbar({
//                         open: true,
//                         message: "E-Invoice generated and stored successfully",
//                         severity: "success"
//                     });
//                 }
//             } else {
//                 throw new Error(generateResponse.data?.message || "E-Invoice generation failed");
//             }

//             /* ================= PRINT JSON IN CONSOLE ================= */
//             console.log("========== E-INVOICE JSON ==========");
//             console.log(eInvoicePayload);
//             console.log("===================================");

//         } catch (e) {
//             const msg = e?.response?.data?.message || e.message || "E-Invoice failed";
//             setEinvoiceError(msg);
//             setSnackbar({ open: true, message: msg, severity: "error" });
//         } finally {
//             setEinvoiceLoading(false);
//         }
//     };

//     const handleDownload = () => {
//         if (!qrCodeData) {
//             setSnackbar({ 
//                 open: true, 
//                 message: 'No QR Code data available', 
//                 severity: 'warning' 
//             });
//             return;
//         }

//         try {
//             const qrCanvas = document.querySelector('canvas');
            
//             if (!qrCanvas) {
//                 setSnackbar({ 
//                     open: true, 
//                     message: 'QR Code canvas not found. Please generate QR code first.', 
//                     severity: 'warning' 
//                 });
//                 return;
//             }

//             qrCanvas.toBlob((blob) => {
//                 if (!blob) {
//                     setSnackbar({ 
//                         open: true, 
//                         message: 'Failed to convert QR code to image', 
//                         severity: 'error' 
//                     });
//                     return;
//                 }

//                 const url = window.URL.createObjectURL(blob);
//                 const link = document.createElement('a');
//                 link.href = url;
//                 link.setAttribute('download', `einvoice-qr-${qrCodeData}.png`);
                
//                 document.body.appendChild(link);
//                 link.click();
                
//                 link.parentNode.removeChild(link);
//                 window.URL.revokeObjectURL(url);

//                 setSnackbar({ 
//                     open: true, 
//                     message: "QR Code downloaded successfully", 
//                     severity: "success" 
//                 });
//             }, 'image/png');

//         } catch (error) {
//             console.error("Download error:", error);
//             setSnackbar({ 
//                 open: true, 
//                 message: `Failed to download QR Code: ${error.message}`, 
//                 severity: "error" 
//             });
//         }
//     };

//     // const handleDownload = () => {
//     //     if (!einvoiceResponse) {
//     //         setSnackbar({ open: true, message: 'No E-Invoice response available', severity: 'warning' });
//     //         return;
//     //     }

//     //     try {
//     //         const qrCanvas = document.querySelector('canvas');
//     //         // Get QR code from response
//     //         const qrCodeBase64 = einvoiceResponse?.data?.signedQRCode;
//     //         const irn = einvoiceResponse?.data?.irn;
//     //         // added line
//     //         setQrCodeData(irn);

//     //         if (!qrCodeBase64) {
//     //             setSnackbar({ open: true, message: 'QR Code not found in response', severity: 'warning' });
//     //             return;
//     //         }

//     //         // Convert base64 to blob and download
//     //         const byteCharacters = atob(qrCodeBase64);
//     //         const byteNumbers = new Array(byteCharacters.length);
//     //         for (let i = 0; i < byteCharacters.length; i++) {
//     //             byteNumbers[i] = byteCharacters.charCodeAt(i);
//     //         }
//     //         const byteArray = new Uint8Array(byteNumbers);
//     //         const blob = new Blob([byteArray], { type: 'image/png' });

//     //         const url = window.URL.createObjectURL(blob);
//     //         const link = document.createElement('a');
//     //         link.href = url;
//     //         link.setAttribute('download', `einvoice-qr-${irn}.png`);
//     //         document.body.appendChild(link);
//     //         link.click();
//     //         link.parentNode.removeChild(link);
//     //         window.URL.revokeObjectURL(url);

//     //         setSnackbar({ open: true, message: "QR Code downloaded successfully", severity: "success" });
//     //     } catch (error) {
//     //         console.error("Download error:", error);
//     //         setSnackbar({ open: true, message: "Failed to download QR Code", severity: "error" });
//     //     }
//     // };

//     /* ================= UPDATE E-INVOICE IN MASTER TABLES (NEW) ================= */
//     // const updateEinvoiceInMasterTables = async (responseData) => {
//     //     try {
//     //         const irnNo = responseData?.data?.irn || "";
//     //         const irnDate = responseData?.data?.ackDt || "";
//     //         const ackNo = responseData?.data?.ackNo || "";
//     //         const ackDate = responseData?.data?.ackDt || "";

//     //         const updatePayload = {
//     //             companyId,
//     //             userId: user?.UserId,
//     //             bookName,
//     //             invoiceId,
//     //             IRNNo: irnNo,
//     //             IRNDate: irnDate,
//     //             ACKNo: ackNo,
//     //             ACKDate: ackDate
//     //         };

//     //         console.log("Updating E-Invoice in master tables with payload:", updatePayload);

//     //         const updateResponse = await axios.post(
//     //             `${connectionString}/api/update-einvoice-master`,
//     //             updatePayload
//     //         );

//     //         if (updateResponse.data?.success) {
//     //             console.log("✅ E-Invoice master tables updated successfully");
//     //             return true;
//     //         } else {
//     //             throw new Error(updateResponse.data?.message || "Failed to update E-Invoice master");
//     //         }
//     //     } catch (error) {
//     //         console.error("❌ Update E-Invoice Master Error:", error);
//     //         // Don't throw error - storage succeeded even if update fails
//     //         console.log("E-Invoice stored successfully, but master update failed");
//     //         return false;
//     //     }
//     // };

//     /* ================= UI – REDESIGNED TO MATCH STYLE ================= */
//     return (
//         <Box sx={{ bgcolor: 'white', p: 1.5, fontFamily: 'Arial, sans-serif' }}>
//             <Paper
//                 elevation={0}
//                 sx={{
//                     border: '1px solid #ccc',
//                     maxWidth: 1200,
//                     mx: 'auto',
//                     overflow: 'hidden',
//                     bgcolor: '#fffef5',
//                 }}
//             >
//                 {/* Header – matched style */}
//                 {/* <Box sx={{ bgcolor: '#fffacd', p: 1.5, borderBottom: '2px solid #d4a574', textAlign: 'center' }}>
//                     <Typography variant="h6" fontWeight="bold" color="#000">
//                         E-INVOICE BILL SYSTEM
//                     </Typography>
//                 </Box> */}

//                 <Box sx={{ p: 2 }}>
//                     <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
//                         {/* <Box sx={{ maxWidth: 1100, mx: 'auto', px: 2, py: 1 }}>
                   
//                             <Grid container spacing={1.5} justifyContent="center">
//                                 <Grid item xs={12} sm={6}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             E-Invoice Username
//                                         </Typography>
//                                         {renderTextField('', 'EIUserName', true, false, true)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             E-Invoice Password
//                                         </Typography>
//                                         {renderTextField('', 'EIPassword', true, false, true, 'password')}
//                                     </Box>
//                                 </Grid>
//                             </Grid>

//                             <Divider sx={{ my: 2.5 }} />

              
//                             <Grid container spacing={1.5} justifyContent="center">
//                                 <Grid item xs={12} sm={4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Party Name
//                                         </Typography>
//                                         {renderTextField('', 'partyName', true, false, true)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Bill No
//                                         </Typography>
//                                         {renderTextField('', 'billNo', true, false, true)}
//                                     </Box>
//                                 </Grid>
//                             </Grid>

                    
//                             <Grid container spacing={1.5} justifyContent="center" sx={{ mt: 2 }}>
//                                 <Grid item xs={12} sm={3}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Sub Type
//                                         </Typography>
//                                         {renderSelect('', 'subType', subTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={3}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Doc Type
//                                         </Typography>
//                                         {renderSelect('', 'docType', docTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={3}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Trans Mode
//                                         </Typography>
//                                         {renderSelect('', 'transMode', transModeOptions)}
//                                     </Box>
//                                 </Grid>
//                             </Grid>

                 
//                             <Grid container spacing={1.5} justifyContent="center" sx={{ mt: 2 }}>
//                                 <Grid item xs={12} sm={6} md={2.4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Vehicle Type
//                                         </Typography>
//                                         {renderSelect('', 'vehicleType', vehicleTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={2.4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             Distance (Km)
//                                         </Typography>
//                                         {renderTextField('', 'distance')}
//                                     </Box>
//                                 </Grid>
//                                 <Grid item xs={12} sm={6} md={2.4}>
//                                     <Box sx={{ display: 'flex', flexDirection: 'column' }}>
//                                         <Typography variant="subtitle2" sx={{ fontSize: '0.85rem', mb: 0.5, fontWeight: 500 }}>
//                                             TransType
//                                         </Typography>
//                                         {renderSelect('', 'transType', transTypeOptions)}
//                                     </Box>
//                                 </Grid>
//                             </Grid>
//                         </Box> */}

//                         <Box sx={{ mt: 2.5 }}>

//                             <Typography variant="subtitle2" sx={{ fontSize: '0.9rem', mb: 1, fontWeight: 600 }}>
//                                 E-Invoice IRN / Response Details
//                             </Typography>

//                             <Box sx={{ position: 'relative', mb: 2 }}>
//                                 {renderTextField(
//                                     einvoiceError ? `Error: ${einvoiceError}` : 'E-Invoice IRN / Response',
//                                     'einvoiceNo',
//                                     false,
//                                     true,
//                                     true
//                                 )}
//                                 {einvoiceError && (
//                                     <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
//                                         {einvoiceError}
//                                     </Typography>
//                                 )}
//                             </Box>

//                             {/* Action Buttons – matched placement & style */}
//                             <Box sx={{ mt: 3 }}>

//                                 {/* ================= BUTTON ROW ================= */}
//                                 <Box
//                                     sx={{
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         gap: 2,
//                                         flexWrap: 'wrap'
//                                     }}
//                                 >
//                                     <Button
//                                         variant="contained"
//                                         color="primary"
//                                         size="medium"
//                                         onClick={handleSubmit}
//                                         disabled={
//                                             einvoiceLoading ||
//                                             einvoiceSuccess ||
//                                             Object.keys(vehicleValidationErrors).length > 0
//                                         }
//                                         sx={{
//                                             minWidth: 180,
//                                             fontWeight: 600
//                                         }}
//                                     >
//                                         {einvoiceLoading ? (
//                                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                                 <CircularProgress size={18} color="inherit" />
//                                                 Generating...
//                                             </Box>
//                                         ) : (
//                                             'Generate E-Invoice'
//                                         )}
//                                     </Button>

//                                     {einvoiceResponse?.data?.signedQRCode && (
//                                         <Button
//                                             variant="contained"
//                                             color="success"
//                                             size="medium"
//                                             startIcon={<GetApp />}
//                                             onClick={handleDownload}
//                                             sx={{ minWidth: 180, fontWeight: 600 }}
//                                         >
//                                             Download QR Code
//                                         </Button>
//                                     )}
//                                 </Box>


//                                 {/* ================= QR PREVIEW SECTION ================= */}
//                                 {einvoiceResponse?.data?.signedQRCode && (
//                                     <Paper
//                                         elevation={3}
//                                         sx={{
//                                             mt: 4,
//                                             p: 3,
//                                             maxWidth: 360,
//                                             mx: 'auto',
//                                             textAlign: 'center',
//                                             borderRadius: 3,
//                                             bgcolor: '#ffffff'
//                                         }}
//                                     >
//                                         <Typography
//                                             variant="h6"
//                                             sx={{ fontWeight: 600, mb: 2 }}
//                                         >
//                                             E-Invoice QR Code
//                                         </Typography>

//                                         {/* Debug Length (Remove Later If Not Needed) */}
//                                         <Typography
//                                             variant="caption"
//                                             sx={{ display: "block", mb: 1, color: "gray" }}
//                                         >
//                                             QR Length: {einvoiceResponse?.data?.signedQRCode?.length}
//                                         </Typography>

//                                         <Box
//                                             sx={{
//                                                 p: 2,
//                                                 border: '1px solid #e0e0e0',
//                                                 borderRadius: 2,
//                                                 bgcolor: '#fafafa',
//                                                 display: 'inline-block'
//                                             }}
//                                         >
//                                             {/* <img
//                                                 // src={
//                                                 //     einvoiceResponse.data.signedQRCode.startsWith("data:image")
//                                                 //         ? einvoiceResponse.data.signedQRCode
//                                                 //         : `data:image/png;base64,${einvoiceResponse.data.signedQRCode}`
//                                                 // }
//                                                 src={
//                                                     einvoiceResponse.data.signedQRCode
//                                                         ? (einvoiceResponse.data.signedQRCode.startsWith("data:image") 
//                                                             ? einvoiceResponse.data.signedQRCode
//                                                             : einvoiceResponse.data.signedQRCode.startsWith("iVBORw0KGgo") 
//                                                                 ? `data:image/png;base64,${einvoiceResponse.data.signedQRCode}`
//                                                                 : einvoiceResponse.data.signedQRCode.startsWith("/9j/") 
//                                                                     ? `data:image/jpeg;base64,${einvoiceResponse.data.signedQRCode}`
//                                                                     : `data:image/png;base64,${einvoiceResponse.data.signedQRCode}`)
//                                                         : ''
//                                                 }
//                                                 alt="E-Invoice QR"
//                                                 // onError={(e) => {
//                                                 //     console.error("QR Image Load Error:", e);
//                                                 //     e.target.src = '';
//                                                 // }}
//                                                 style={{
//                                                     width: 220,
//                                                     height: 220,
//                                                     objectFit: "contain"
//                                                 }}
//                                             /> */}
//                                             <QRCode
//                                                 value={qrCodeData}        // The data to encode (IRN)
//                                                 size={220}                // Size in pixels
//                                                 level="H"                 // Error correction level (H = 30%)
//                                                 includeMargin={true}      // Add quiet zone
//                                                 renderAs="canvas"         // Render as canvas for better quality
//                                             />
//                                         </Box>
//                                     </Paper>
//                                 )}

//                             </Box>
//                         </Box>
//                     </Box>
//                 </Box>
//             </Paper>

//             {/* Snackbar */}
//             <Snackbar
//                 open={snackbar.open}
//                 autoHideDuration={4000}
//                 onClose={() => setSnackbar(p => ({ ...p, open: false }))}
//                 anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
//             >
//                 <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
//                     {snackbar.message}
//                 </Alert>
//             </Snackbar>

//             {submitError && (
//                 <Alert severity="error" sx={{ mt: 1.5, maxWidth: 1200, mx: 'auto' }}>
//                     {submitError}
//                 </Alert>
//             )}
//         </Box>
//     );
// };

// export default EInvoiceMaster;

import { useState, useEffect } from 'react';
import {
    Box, Grid, TextField, Button, Typography, Select,
    MenuItem, FormControl, InputLabel, Paper,
    Alert, Snackbar, CircularProgress, Divider, Checkbox, FormControlLabel
} from '@mui/material';
import { GetApp } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';
import { useLocation } from "react-router-dom";
import axios from "axios";
// ✅ CORRECT IMPORT
import { QRCodeCanvas } from 'qrcode.react';

/* ================= UTIL FUNCTIONS ================= */
const toTitleCase = (str = "") =>
    str
        .toLowerCase()
        .split(" ")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ");

const formatDateToDDMMYYYY = (dateStr = "") => {
    if (!dateStr) return "";
    const [yyyy, mm, dd] = dateStr.split("-");
    return `${dd}/${mm}/${yyyy}`;
};

const formatDateTimeToMySQLFormat = (dateStr = "") => {
    if (!dateStr) return "";
    if (dateStr.includes("T")) {
        return dateStr.replace("T", " ").split(".")[0];
    }
    const [dd, mm, yyyy] = dateStr.split("/");
    return `${yyyy}-${mm}-${dd}`;
};

const limitTo120Chars = (v = "") =>
    String(v).length > 120 ? String(v).slice(0, 120) : String(v);

const splitAddress120 = (address = "") => {
    // Line breaks (\r, \n) in an address are replaced with a space
    const str = String(address).replace(/[\r\n]+/g, " ");
    return {
        addr1: str.slice(0, 100),
        addr2: str.length > 100 ? str.slice(100, 200) : ""
    };
};

/* ================= COMPONENT ================= */
// ================= VALIDATION & MAPPING FUNCTIONS =================
// Map TransactionType to SupTyp
const getSupTypFromTransactionType = (transactionType) => {
    const typeMap = {
        "Regular": "B2B",
        "SEZ Exempted": "SEZWOP",
        "SEZ Tax Pay": "SEZWP",
        "Export With Tax Pay": "EXPWP",
        "Export Without Tax Pay": "EXPWOP"
    };
    return typeMap[transactionType] || "B2B";
};

// Check if HSN code indicates service (starts with 99)
const isService = (hsnCode) => {
    return String(hsnCode || "").startsWith("99");
};

// Validate Client Pincode (6-digit numeric)
const validateClientPincode = (pincode) => {
    const pincodeStr = String(pincode || "").trim();
    const pincodeRegex = /^\d{6}$/;
    return pincodeRegex.test(pincodeStr);
};

// Validate Transporter Name (not empty)
const validateTransporterName = (name) => {
    return String(name || "").trim() !== "";
};

// Validate Product Name/Description
const validateProductName = (name) => {
    return String(name || "").trim() !== "";
};

// Validate ShipTo Details (not empty)
const validateShipToDetails = (shipTo) => {
    if (!shipTo) return false;
    const hasName = String(shipTo.clientname || "").trim() !== "";
    const hasPin = String(shipTo.pincode || "").trim() !== "";
    const hasState = String(shipTo.stateCode || "").trim() !== "";
    return hasName && hasPin && hasState;
};

const EInvoiceMaster = ({ connectionString, invoiceId, bookName }) => {
    const { user, selectedCompany } = useAuth();
    const companyId = selectedCompany?.CompId || null;

    const [formState, setFormState] = useState({
        EIUserName: '',
        EIPassword: '',
        partyName: '',
        billNo: '',
        einvoiceNo: '',
        subType: 'B2B',
        docType: 'Tax Invoice',
        transMode: 'Road',
        vehicleType: 'Regular',
        distance: '',
        transType: 'Regular',
        gstNo: '',
    });

    const [errors, setErrors] = useState({});
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [einvoiceData, setEinvoiceData] = useState(null);
    const [einvoiceLoading, setEinvoiceLoading] = useState(false);
    const [einvoiceSuccess, setEinvoiceSuccess] = useState(false);
    const [einvoiceError, setEinvoiceError] = useState('');
    const [submitError, setSubmitError] = useState('');
    const [stateList, setStateList] = useState([]);
    const [vehicleValidationErrors, setVehicleValidationErrors] = useState({});
    const [einvoiceResponse, setEinvoiceResponse] = useState(null);
    const [qrCodeData, setQrCodeData] = useState(null);
    const [specValidationIssues, setSpecValidationIssues] = useState([]);
    const [isServiceBill, setIsServiceBill] = useState(false);
    const [isEwayBillRequired, setIsEwayBillRequired] = useState(false);
    const [einvoiceServer, setEinvoiceServer] = useState('Primary');

    /* ================= EFFECTS ================= */
    useEffect(() => {
        if (!companyId) return;
        axios.get(`${connectionString}/api/ewaybill/getCompanyUserNameandPassword`, {
            params: { companyId, mode: "EI" }
        }).then(res => {
            if (res.data?.success) {
                setFormState(p => ({
                    ...p,
                    EIUserName: res.data.data.username,
                    EIPassword: res.data.data.password,
                    gstNo: res.data.data.gstNo
                }));
            }
        }).catch(err => {
            console.error("Failed to fetch company credentials", err);
        });
    }, [companyId]);

    useEffect(() => {
        if (!invoiceId || !bookName) return;
        fetchEinvoiceData(invoiceId, bookName);
    }, [invoiceId, bookName]);

    useEffect(() => {
        if (!companyId) return;
        axios.get(`${connectionString}/api/states`, { params: { companyId } })
            .then(res => setStateList(res.data))
            .catch(err => console.error("States fetch failed", err));
    }, [companyId]);

    const getTransTypeByPincode = (data) => {
        const companyPin = Number(data?.company?.pincode || "");
        const shipFromPin = Number(data?.consigner?.shipFrom?.pincode || data?.company?.pincode || "");
        const clientPin = Number(data?.client?.details?.pincode || "");
        const shipToPin = Number(data?.consigner?.shipTo?.pincode || data?.client?.details?.pincode || "");

        if (companyPin === shipFromPin && clientPin === shipToPin) {
            return "Regular";
        }
        if (companyPin === shipFromPin && clientPin !== shipToPin) {
            return "Bill To-Ship To";
        }
        if (companyPin !== shipFromPin && clientPin === shipToPin) {
            return "Bill From-Disaptch From";
        }
        if (companyPin !== shipFromPin && shipToPin !== clientPin) {
            return "Combination of 2 and 3";
        }
        return "Regular";
    };

    const validateEinvoicePageLoad = (data) => {
        const pageLoadErrors = [];
        const ADDRESS_CHARSET_REGEX = /^[a-zA-Z0-9~!@#$%^&*()_\-+=\\;:'\".\/, ]*$/;
        const PRODUCT_CHARSET_REGEX = /^[a-zA-Z0-9\-\/. ]*$/;
        const NAME_CHARSET_REGEX = /^[a-zA-Z0-9\-\/. ]*$/;

        // ✅ 1. Client Pincode Validation
        const clientPincode = String(data?.client?.details?.pincode || "").trim();
        if (!clientPincode || !/^\d{6}$/.test(clientPincode)) {
            pageLoadErrors.push("Client Pincode is required and must be a valid 6-digit pincode");
        }

        // ✅ 2. Shipment Pincode Validation (NEW - from EwayBill) - Optional, but if exists must be 6 digits
        const shipToPincode = String(data?.consigner?.shipTo?.pincode || "").trim();
        if (shipToPincode && !/^\d{6}$/.test(shipToPincode)) {
            pageLoadErrors.push("Shipment Pincode must be a valid 6-digit pincode");
        }

        // ✅ 3. Transporter Name Validation
        const transporterName = String(data?.transporter?.transporterName || "").trim();
        if (!transporterName) {
            pageLoadErrors.push("Transporter Name is required");
        }

        // ✅ 4. GSTIN Length Validation (NEW - from EwayBill)
        const fromGstin = String(data?.company?.gstNo || "URP");
        if (fromGstin && fromGstin !== "URP" && fromGstin.length !== 15) {
            pageLoadErrors.push(`From GSTIN "${fromGstin}" must be 15 characters`);
        }

        const toGstin = String(data?.client?.details?.["GST No."] || "URP");
        if (toGstin && toGstin !== "URP" && toGstin.length !== 15) {
            pageLoadErrors.push(`To GSTIN "${toGstin}" must be 15 characters`);
        }

        // ✅ 5. Address Character Set Validation (NEW - from EwayBill)
        // Same as the E-Way Bill: the address character check is NOT done on page load — only the
        // seller's (From) Address1 / Address2 / Place are checked, in the payload validation below.
        // (previous page-load checks of the seller / buyer / dispatch / ship-to addresses:)
        // const sellerAddr = data?.company?.address || "";
        // if (sellerAddr && !ADDRESS_CHARSET_REGEX.test(sellerAddr)) {
        //     pageLoadErrors.push("Seller Address contains invalid characters (only alphanumeric and the allowed special characters)");
        // }
        // const buyerAddr = data?.client?.details?.address || "";
        // if (buyerAddr && !ADDRESS_CHARSET_REGEX.test(buyerAddr)) {
        //     pageLoadErrors.push("Buyer Address contains invalid characters (only alphanumeric and the allowed special characters)");
        // }
        // const dispatchAddr = data?.consigner?.shipFrom?.Address || "";
        // if (dispatchAddr && !ADDRESS_CHARSET_REGEX.test(dispatchAddr)) {
        //     pageLoadErrors.push("Dispatch Address contains invalid characters (only alphanumeric and the allowed special characters)");
        // }
        // const shipAddr = data?.consigner?.shipTo?.Address || "";
        // if (shipAddr && !ADDRESS_CHARSET_REGEX.test(shipAddr)) {
        //     pageLoadErrors.push("Ship To Address contains invalid characters (only alphanumeric and the allowed special characters)");
        // }

        // ✅ 6. Party Name Character Set Validation (NEW - from EwayBill)
        const buyerName = String(data?.client?.partyName || "");
        if (buyerName && !NAME_CHARSET_REGEX.test(buyerName)) {
            pageLoadErrors.push("Buyer Party Name contains invalid characters (only alphanumeric, hyphen, slash, and dot allowed)");
        }

        const shipToName = String(data?.consigner?.shipTo?.clientname || "");
        if (shipToName && !NAME_CHARSET_REGEX.test(shipToName)) {
            pageLoadErrors.push("Ship To Party Name contains invalid characters (only alphanumeric, hyphen, slash, and dot allowed)");
        }

        // ✅ 7. Distance Validation
        const fromPincode = Number(data?.company?.pincode || "");
        const toPincode = Number(data?.client?.details?.pincode || "");

        const transType = getTransTypeByPincode(data);
        let distanceToCheck = "";
        if (transType === "Regular" || transType === "Bill From-Disaptch From") {
            distanceToCheck = data?.client?.details?.Distance || "";
        } else {
            distanceToCheck = data?.consigner?.shipTo?.Distance || "";
        }

        if (fromPincode && toPincode && fromPincode === toPincode) {
            if (!distanceToCheck || Number(distanceToCheck) <= 0) {
                pageLoadErrors.push("Distance must be greater than 0 when From and To pincodes are the same");
            }
        }

        // ✅ 8. Vehicle Number Validation (NEW - from EwayBill, strict format check)
        const vehicleNo = String(data?.vehicleNo || "").trim();
        const transporterGstNo = String(data?.transporter?.transporterGstNo || "").trim();

        if (transporterName === "SELF" || !transporterGstNo) {
            if (!vehicleNo) {
                pageLoadErrors.push("Vehicle No is required when Transporter is SELF or Transporter GST No is not provided");
            } else if (!/^[A-Z0-9]+$/.test(vehicleNo)) {
                pageLoadErrors.push("Vehicle No should be continuous alphanumeric only (e.g., GJ26JD5356), no spaces or special characters");
            }
        } else {
            if (vehicleNo && !/^[A-Z0-9]+$/.test(vehicleNo)) {
                pageLoadErrors.push("Vehicle No should be continuous alphanumeric only (e.g., GJ26JD5356), no spaces or special characters");
            }
        }

        // ✅ 10. Product Data Validation
        const productData = data?.product?.tableData || [];
        if (productData.length > 0) {
            productData.forEach((item, index) => {
                const productName = String(item.description || "").trim();
                if (!productName) {
                    pageLoadErrors.push(`Product ${index + 1}: Product Name/Description is required`);
                } else if (!PRODUCT_CHARSET_REGEX.test(productName)) {
                    pageLoadErrors.push(`Product ${index + 1}: Product Name "${productName}" contains invalid characters. Only alphanumeric, dots, dashes, and slashes are allowed`);
                }
            });
        }

        return pageLoadErrors;
    };

    // ✅ E-INVOICE SPEC VALIDATION (matches EwayBill validation rules)
    const validateEinvoiceSpecFields = (payload) => {
        const issues = [];
        const PRODUCT_CHARSET_REGEX = /^[a-zA-Z0-9\-\/. ]*$/;
        const ADDRESS_CHARSET_REGEX = /^[a-zA-Z0-9~!@#$%^&*()_\-+=\\;:'\".\/, ]*$/;
        const NAME_CHARSET_REGEX = /^[a-zA-Z0-9\-\/. ]*$/;

        // ✅ 1. GSTIN Validation (NEW - from EwayBill)
        if (payload.SellerDtls?.Gstin && payload.SellerDtls.Gstin !== "URP" && payload.SellerDtls.Gstin.length !== 15) {
            issues.push(`Seller GSTIN "${payload.SellerDtls.Gstin}" must be 15 characters`);
        }
        if (payload.BuyerDtls?.Gstin && payload.BuyerDtls.Gstin !== "URP" && payload.BuyerDtls.Gstin.length !== 15) {
            issues.push(`Buyer GSTIN "${payload.BuyerDtls.Gstin}" must be 15 characters`);
        }
        if (payload.ShipDtls?.Gstin && payload.ShipDtls.Gstin !== "URP" && payload.ShipDtls.Gstin.length !== 15) {
            issues.push(`Ship To GSTIN "${payload.ShipDtls.Gstin}" must be 15 characters`);
        }

        // ✅ 2. Address Charset Validation (NEW - from EwayBill)
        if (payload.SellerDtls?.Addr1 && !ADDRESS_CHARSET_REGEX.test(payload.SellerDtls.Addr1)) {
            issues.push(`Seller Address1 contains invalid characters (only alphanumeric and the allowed special characters)`);
        }
        if (payload.SellerDtls?.Addr2 && !ADDRESS_CHARSET_REGEX.test(payload.SellerDtls.Addr2)) {
            issues.push(`Seller Address2 contains invalid characters (only alphanumeric and the allowed special characters)`);
        }
        if (payload.SellerDtls?.Loc && !ADDRESS_CHARSET_REGEX.test(payload.SellerDtls.Loc)) {
            issues.push(`Seller City/Place contains invalid characters (only alphanumeric and the allowed special characters)`);
        }

        // Same as the E-Way Bill, only the seller's (From) Address1 / Address2 / Place are checked
        // for special characters. The buyer / dispatch / ship-to checks are switched off:
        // if (payload.BuyerDtls?.Addr1 && !ADDRESS_CHARSET_REGEX.test(payload.BuyerDtls.Addr1)) {
        //     issues.push(`Buyer Address1 contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.BuyerDtls?.Addr2 && !ADDRESS_CHARSET_REGEX.test(payload.BuyerDtls.Addr2)) {
        //     issues.push(`Buyer Address2 contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.BuyerDtls?.Loc && !ADDRESS_CHARSET_REGEX.test(payload.BuyerDtls.Loc)) {
        //     issues.push(`Buyer City/Place contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.DispDtls?.Addr1 && !ADDRESS_CHARSET_REGEX.test(payload.DispDtls.Addr1)) {
        //     issues.push(`Dispatch Address1 contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.DispDtls?.Addr2 && !ADDRESS_CHARSET_REGEX.test(payload.DispDtls.Addr2)) {
        //     issues.push(`Dispatch Address2 contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.DispDtls?.Loc && !ADDRESS_CHARSET_REGEX.test(payload.DispDtls.Loc)) {
        //     issues.push(`Dispatch City/Place contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.ShipDtls?.Addr1 && !ADDRESS_CHARSET_REGEX.test(payload.ShipDtls.Addr1)) {
        //     issues.push(`Ship To Address1 contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.ShipDtls?.Addr2 && !ADDRESS_CHARSET_REGEX.test(payload.ShipDtls.Addr2)) {
        //     issues.push(`Ship To Address2 contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }
        // if (payload.ShipDtls?.Loc && !ADDRESS_CHARSET_REGEX.test(payload.ShipDtls.Loc)) {
        //     issues.push(`Ship To City/Place contains invalid characters (only alphanumeric and the allowed special characters)`);
        // }

        // ✅ 3. Party Name Charset Validation (NEW - from EwayBill)
        if (payload.SellerDtls?.LglNm && !NAME_CHARSET_REGEX.test(payload.SellerDtls.LglNm)) {
            issues.push(`Seller Name contains invalid characters (only alphanumeric, hyphen, slash, and dot allowed)`);
        }
        if (payload.BuyerDtls?.LglNm && !NAME_CHARSET_REGEX.test(payload.BuyerDtls.LglNm)) {
            issues.push(`Buyer Name contains invalid characters (only alphanumeric, hyphen, slash, and dot allowed)`);
        }
        if (payload.ShipDtls?.LglNm && !NAME_CHARSET_REGEX.test(payload.ShipDtls.LglNm)) {
            issues.push(`Ship To Name contains invalid characters (only alphanumeric, hyphen, slash, and dot allowed)`);
        }

        // ✅ 4. Shipment Pincode Validation (NEW - from EwayBill)
        if (!payload.BuyerDtls?.Pin || !/^\d{6}$/.test(String(payload.BuyerDtls.Pin))) {
            issues.push(`Buyer Pincode must be a valid 6-digit number`);
        }
        // ✅ ShipDtls is optional, only validate if provided
        if (payload.ShipDtls && payload.ShipDtls?.Pin !== 999999 && payload.ShipDtls?.Pin && !/^\d{6}$/.test(String(payload.ShipDtls.Pin))) {
            issues.push(`Ship To Pincode must be a valid 6-digit number (or 999999 for other countries)`);
        }

        // ✅ 5. Dispatch Pincode Validation (NEW - from EwayBill)
        if (payload.DispDtls?.Pin && !/^\d{6}$/.test(String(payload.DispDtls.Pin))) {
            issues.push(`Dispatch Pincode must be a valid 6-digit number`);
        }

        // ✅ 6. ItemList Validation
        (payload.ItemList || []).forEach((item, idx) => {
            const rowLabel = `Item #${item.SlNo || idx + 1}`;

            // Unit: max 3 characters
            if (item.Unit && String(item.Unit).length !== 3) {
                issues.push(`${rowLabel}: Unit "${item.Unit}" should have only 3 characters`);
            }

            // Product Description charset validation
            if (item.PrdDesc && !PRODUCT_CHARSET_REGEX.test(item.PrdDesc)) {
                issues.push(`${rowLabel}: Product description contains invalid characters (only alphanumeric, dots, dashes, and slashes are allowed)`);
            }

            // Quantity must be > 0
            if (!item.Qty || Number(item.Qty) <= 0) {
                issues.push(`${rowLabel}: Quantity must be greater than 0`);
            }

            // Unit Price must be >= 0
            if (item.UnitPrice === undefined || item.UnitPrice === null || Number(item.UnitPrice) < 0) {
                issues.push(`${rowLabel}: Unit Price must be a valid non-negative number`);
            }

            // Total Amount must be >= 0
            if (item.TotAmt === undefined || item.TotAmt === null || Number(item.TotAmt) < 0) {
                issues.push(`${rowLabel}: Total Amount must be a valid non-negative number`);
            }
        });

        return issues;
    };

    const fetchEinvoiceData = async (id, bookName) => {
        try {
            const endpoint =
                bookName === 'SALE'
                    ? `${connectionString}/api/ewaybill/by-invoice/${id}`
                    : bookName === 'CRNT'
                        ? `${connectionString}/api/ewaybill/by-creditNote/${id}`
                        : null;
            const { data } = await axios.get(endpoint, { params: { companyId, bookName } });
            setEinvoiceData(data);
            console.log("data:", data);

            const transporterName = data?.transporter?.transporterName || "";
            const transporterGstNo = data?.transporter?.transporterGstNo || "";
            const vehicleNo = data?.vehicleNo || "";

            if (
                transporterName.toUpperCase() === "SELF" ||
                !transporterGstNo.trim()
            ) {
                if (!vehicleNo.trim()) {
                    setVehicleValidationErrors({ vehicleNo: "Vehicle No is required when transporter is SELF or GST No is not provided" });

                    setSnackbar({
                        open: true,
                        severity: "warning",
                        message: "Vehicle No is required when transporter is SELF or GST No is not provided"
                    });
                } else {
                    setVehicleValidationErrors({});
                }
            } else {
                setVehicleValidationErrors({});
            }

            const pageLoadErrors = validateEinvoicePageLoad(data);
            if (pageLoadErrors.length > 0) {
                setSpecValidationIssues(pageLoadErrors);
                setSubmitError(`E-Invoice data has the following issues:\n${pageLoadErrors.map((i) => `• ${i}`).join('\n')}`);
            } else {
                setSpecValidationIssues([]);
                setSubmitError('');
            }

            // ✅ ADDED: Get distance based on transType (matches EwayBill logic)
            const transType = getTransTypeByPincode(data);
            let distanceValue = "";
            if (transType === "Regular" || transType === "Bill From-Disaptch From") {
                distanceValue = data?.client?.details?.Distance || "";
            } else {
                distanceValue = data?.consigner?.shipTo?.Distance || "";
            }

            setFormState(p => ({
                ...p,
                partyName: data?.client?.partyName || "",
                billNo: data?.client?.BillNumber || "",
                transType: transType,
                docType:
                    bookName === "SALE"
                        ? "Tax Invoice"
                        : bookName === "SACH"
                            ? "Delivery Challan"
                            : p.docType,
                supplyType: bookName === "SALE" || bookName === "SACH"
                    ? "Outward"
                    : bookName === "CRNT"
                        ? "Inward"
                        : p.supplyType,
                subType: getSupTypFromTransactionType(data?.client?.TransactionType || "Regular"),
                transMode: data?.transMode || p.transMode,
                vehicleType: data?.vehicleType || p.vehicleType,
                dispatchState: data?.client?.details?.State ? toTitleCase(data.client.details.State) : p.dispatchState,
                shipToState: data?.client?.details?.State ? toTitleCase(data.client.details.State) : p.shipToState,
                distance: distanceValue,
            }));
        } catch {
            setSnackbar({ open: true, message: "Failed to load invoice", severity: "error" });
        }
    };

    /* ================= HELPERS ================= */
    const handleChange = e => {
        const { name, value } = e.target;
        setFormState(p => ({ ...p, [name]: value }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const renderTextField = (label, name, required = false, multiline = false, disabled = false, type = 'text') => (
        <TextField
            fullWidth
            label={label}
            name={name}
            value={formState[name] || ''}
            onChange={handleChange}
            error={!!errors[name]}
            helperText={errors[name]}
            required={required}
            multiline={multiline}
            minRows={multiline ? 4 : 1}
            disabled={disabled}
            type={type}
            variant="outlined"
            size="small"
            sx={{
                '& .MuiOutlinedInput-root': { fontSize: '0.9rem' },
                '& .MuiInputLabel-root': { fontSize: '0.85rem' },
            }}
        />
    );

    const renderSelect = (label, name, options) => (
        <FormControl fullWidth size="small">
            <InputLabel sx={{ fontSize: '0.85rem' }}>{label}</InputLabel>
            <Select
                name={name}
                value={formState[name] || options[0]}
                label={label}
                onChange={handleChange}
            >
                {options.map(o => (
                    <MenuItem key={o} value={o}>{o}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );

    /* ================= OPTIONS ================= */
    const subTypeOptions = ['B2B', 'SEZWP', 'SEZWOP', 'EXPWP', 'EXPWOP', 'DEXP'];
    const docTypeOptions = ['Tax Invoice', 'Bill of Supply'];
    const transModeOptions = ['Road', 'Rail', 'Air', 'Ship / Road cum Ship'];
    const vehicleTypeOptions = ['Regular', 'ODC'];
    const transTypeOptions = ['Regular', 'Bill To-Ship To', 'Bill From-Disaptch From', 'Combination of 2 and 3'];
    const transModeMap = { Road: 1, Rail: 2, Air: 3, 'Ship / Road cum Ship': 4, };
    const vehicleTypeMap = { Regular: 'R', ODC: 'O', };
    const STATE_OPTIONS = stateList.map(s => toTitleCase(s.state));
    const sellerAddress = splitAddress120(einvoiceData?.company?.address);
    const buyerAddress = splitAddress120(einvoiceData?.client?.details?.address);
    const DispDtlsAddress = splitAddress120(einvoiceData?.consigner?.shipFrom?.Address);
    const ShipDtlsAddress = splitAddress120(einvoiceData?.consigner?.shipTo?.Address);

    const getDocTypeCode = () => {
        if (bookName === "SALE") return "INV";
        return undefined;
    };

    /* ================= PARSE GENERATE RESPONSE ================= */
    // API shape: { success, data: { authtoken, server, result: <IRP response> } }
    // IRP response: { Status: "1"|"0", ErrorDetails, Data: { AckNo, AckDt, Irn, SignedQRCode, QrCodeImage, ... } }
    const parseEinvoiceResult = (apiBody) => {
        const gov = apiBody?.data?.result ?? apiBody?.data ?? {};
        if (String(gov?.Status) === "0") {
            const msg = (gov?.ErrorDetails || []).map(e => e?.ErrorMessage).filter(Boolean).join(" | ")
                || gov?.Message || "E-Invoice generation failed";
            throw new Error(msg);
        }
        let d = gov?.Data;
        if (typeof d === "string") { try { d = JSON.parse(d); } catch { d = null; } }
        d = d || gov;
        const irn = d?.Irn || d?.irn || "";
        if (!irn) throw new Error(gov?.Message || "IRN not received from GST portal");
        return {
            irn,
            ackNo: String(d?.AckNo ?? d?.ackNo ?? ""),
            ackDt: d?.AckDt || d?.ackDt || "",
            signedQRCode: d?.QrCodeImage || d?.SignedQRCode || d?.signedQRCode || "",
            ewayBillNo: String(d?.EwbNo ?? d?.ewbNo ?? ""),
            ewayBillDt: d?.EwbDt || d?.ewbDt || ""
        };
    };

    /* ================= STORE E-INVOICE IN DATABASE ================= */
    const storeEinvoiceInDatabase = async (responseData, rawPortalResponse) => {
        try {
            const parsed = responseData?.data ?? responseData;
            const irnNo = parsed?.irn || "";
            const invQRDetails = parsed?.signedQRCode || "";
            const ackNo = parsed?.ackNo || "";
            const ackDt = parsed?.ackDt || "";
            const ewayBillNo = parsed?.ewayBillNo || "";
            const ewayBillDt = parsed?.ewayBillDt || "";

            const storagePayload = {
                companyId,
                bookName,
                invoiceId,
                userId: user?.UserId,
                branchId: user?.BranchId || "",
                // ✅ Raw E-Invoice portal response (stringified) is stored in
                // gstinfo.FYear instead of the financial year, per requirement.
                fYear: rawPortalResponse ? JSON.stringify(rawPortalResponse) : "",
                mode: "EINVOICE",
                IRNNo: irnNo,
                IRNDate: ackDt,
                INVQRDetails: invQRDetails,
                ACKNo: ackNo,
                ACKDate: ackDt,
                // Only present when "Is EwayBill Required?" was checked and the
                // GST portal returned an e-way bill alongside the e-invoice
                ...(isEwayBillRequired && ewayBillNo ? { EwayBillNumber: ewayBillNo, EwayBillDate: ewayBillDt } : {})
            };

            console.log("Storing E-Invoice with payload:", storagePayload);

            const storeResponse = await axios.post(
                `${connectionString}/api/store-einvoice`,
                storagePayload
            );

            if (storeResponse.data?.success) {
                setSnackbar({
                    open: true,
                    message: storeResponse.data?.message || "E-Invoice stored successfully",
                    severity: "success"
                });
                return true;
            } else {
                throw new Error(storeResponse.data?.message || "Failed to store E-Invoice");
            }
        } catch (error) {
            console.error("Store E-Invoice Error:", error);
            setSnackbar({
                open: true,
                message: error?.response?.data?.message || error.message || "Failed to store E-Invoice",
                severity: "error"
            });
            return false;
        }
    };

    useEffect(() => {
        if (!invoiceId || !bookName || !companyId) return;
        checkEinvoiceExists();
    }, [invoiceId, bookName, companyId]);

    const checkEinvoiceExists = async () => {
        try {
            if (!companyId || !bookName || !invoiceId) return;

            const response = await axios.get(
                `${connectionString}/api/check-einvoice-exists`,
                {
                    params: {
                        companyId,
                        bookName,
                        invoiceId
                    }
                }
            );

            if (response.data?.success && response.data?.exists) {

                const data = response.data.data;

                const irnNo = data?.IRNNo || "";
                const qrBase64 = data?.INVQRDetails || "";
                const ackNo = data?.ACKNo || "";
                const ackDt = data?.ACKDate || "";

                console.log("=== E-INVOICE ALREADY EXISTS ===");
                console.log("IRN No:", irnNo);
                console.log("ACK No:", ackNo);
                console.log("ACK Date:", ackDt);
                console.log("INVQRDetails (Base64) Length:", qrBase64?.length);
                console.log("================================");

                setFormState(prev => ({
                    ...prev,
                    einvoiceNo: irnNo
                }));

                setQrCodeData(irnNo);

                setEinvoiceResponse({
                    data: {
                        irn: irnNo,
                        signedQRCode: qrBase64,
                        ackNo: ackNo,
                        ackDt: ackDt
                    }
                });

                setEinvoiceSuccess(true);

                setSnackbar({
                    open: true,
                    message: "E-Invoice already exists for this document",
                    severity: "info"
                });

            } else {
                console.log("No existing E-Invoice found.");
                setEinvoiceSuccess(false);
            }

        } catch (error) {
            console.error("Error checking E-Invoice existence:", error);
            setSnackbar({
                open: true,
                message: "Failed to check E-Invoice existence",
                severity: "error"
            });
        }
    };

    /* ================= SUBMIT & DOWNLOAD ================= */
    const handleSubmit = async () => {
        setEinvoiceLoading(true);
        setEinvoiceError('');
        setSubmitError('');
        setEinvoiceSuccess(false);

        const gstin = formState.gstNo;
        const username = formState.EIUserName;
        const password = formState.EIPassword;

        let eInvoicePayload = null;

        try {
            if (!einvoiceData) {
                throw new Error("Invoice data not loaded");
            }

            // Validate TransactionType and SupTyp mapping
            const transactionType = einvoiceData?.client?.TransactionType;
            if (!transactionType) {
                throw new Error("Transaction Type is required to generate E-Invoice for E-way Bill. Please ensure the invoice has a valid Transaction Type (Regular, SEZ Exempted, SEZ Tax Pay, Export With Tax Pay, or Export Without Tax Pay)");
            }

            const validTransactionTypes = ["Regular", "SEZ Exempted", "SEZ Tax Pay", "Export With Tax Pay", "Export Without Tax Pay"];
            if (!validTransactionTypes.includes(transactionType)) {
                throw new Error(`Invalid Transaction Type: "${transactionType}". Allowed values are: ${validTransactionTypes.join(", ")}`);
            }

            const mappedSupTyp = getSupTypFromTransactionType(transactionType);
            console.log(`✅ [Transaction Type Validation] Type: "${transactionType}" → SupTyp: "${mappedSupTyp}"`);

            // Skip authorization and directly build payload for debugging/testing
            console.log('ℹ️ [INFO] Skipping authorization - building payload only for preview');
            console.log('🔐 [INFO] Credentials - GSTIN:', gstin, '| Username:', username);

            // ✅ Build the complete E-Invoice JSON payload on the backend (logic unchanged, just moved)
            const buildResponse = await axios.post(`${connectionString}/api/einvoice/build-payload`, {
                einvoiceData,
                bookName,
                formState,
                isServiceBill,
                isEwayBillRequired
            });

            if (!buildResponse.data?.success) {
                throw new Error(buildResponse.data?.message || "Failed to build E-Invoice payload");
            }

            eInvoicePayload = buildResponse.data.payload;
            const specIssues = buildResponse.data.specIssues || [];
            if (specIssues.length > 0) {
                console.warn("E-Invoice spec validation failed:", specIssues);
                const error = new Error(specIssues.join(" | "));
                error.specIssues = specIssues;
                throw error;
            }

            // Print payload JSON before API call
            console.log("========== E-INVOICE JSON PAYLOAD ==========");
            console.log(JSON.stringify(eInvoicePayload));
            console.log("==========================================");

            // E-Invoice generate API (auth + generate) - response JSON is printed below
            const generateResponse = await axios.post(
                // 'http://192.168.1.248:5001/api/e-invoice/generate-with-auth',
                // 'http://103.133.215.205:5000/api/e-invoice/generate-with-auth',
                'https://gstservice.reonbook.com/api/e-invoice/generate-with-auth',
                JSON.stringify(eInvoicePayload),
                {
                    headers: { 'Content-Type': 'application/json' },
                    params: {
                        username: formState.EIUserName,
                        einvpwd: formState.EIPassword,
                        gstin: formState.gstNo,
                        server: einvoiceServer
                    }
                }
            );

            console.log("========== E-INVOICE GENERATE RESPONSE (JSON) ==========");
            console.log(JSON.stringify(generateResponse.data));
            console.log("========================================================");

            const parsedEinvoice = parseEinvoiceResult(generateResponse.data);
            if (generateResponse.data?.success && parsedEinvoice) {

                setEinvoiceResponse({ data: parsedEinvoice });

                const irn = parsedEinvoice.irn;
                setQrCodeData(irn);

                const stored = await storeEinvoiceInDatabase({ data: parsedEinvoice }, generateResponse.data);

                if (stored) {
                    setFormState(p => ({
                        ...p,
                        einvoiceNo: parsedEinvoice.irn || ""
                    }));

                    setEinvoiceSuccess(true);
                    setSnackbar({
                        open: true,
                        message: "E-Invoice generated and stored successfully",
                        severity: "success"
                    });
                }
            } else {
                throw new Error(generateResponse.data?.message || "E-Invoice generation failed");
            }

        } catch (e) {
            // ✅ ADDED: Handle spec validation errors (matches EwayBill pattern)
            if (e.specIssues && e.specIssues.length > 0) {
                setSubmitError(`E-Invoice validation failed:\n${e.specIssues.map((i) => `• ${i}`).join('\n')}`);
                setEinvoiceError(e.specIssues.join(' | '));
                setSnackbar({
                    open: true,
                    message: `E-Invoice validation failed (${e.specIssues.length} issue${e.specIssues.length > 1 ? 's' : ''}). See details below.`,
                    severity: "error"
                });
            } else {
                if (e?.response?.data) {
                    console.log("========== E-INVOICE ERROR RESPONSE (JSON) ==========");
                    console.log(JSON.stringify(e.response.data));
                }
                // Print payload in console even if E-Invoice generation fails
                console.log("========== E-INVOICE JSON (PAYLOAD) ==========");
                if (eInvoicePayload) {
                    console.log(JSON.stringify(eInvoicePayload));
                } else {
                    console.log("❌ Payload not created - error occurred before payload generation");
                    console.log("Error occurred at:", e.message);
                }
                console.log("=============================================");

                const msg = e?.response?.data?.message || e.message || "E-Invoice failed";
                setEinvoiceError(msg);
                setSnackbar({ open: true, message: msg, severity: "error" });
            }
        } finally {
            setEinvoiceLoading(false);
        }
    };

    // ✅ CORRECTED handleDownload
    // Government QR stored in INVQRDetails: base64 image (QrCodeImage) or signed QR token (SignedQRCode)
    const getQrImageSrc = () => {
        const qr = String(einvoiceResponse?.data?.signedQRCode || "").trim();
        if (!qr) return "";
        if (qr.startsWith("data:image")) return qr;
        if (qr.startsWith("iVBORw0KGgo")) return `data:image/png;base64,${qr}`;
        if (qr.startsWith("/9j/")) return `data:image/jpeg;base64,${qr}`;
        return "";
    };

    const handleDownload = () => {
        if (!qrCodeData) {
            setSnackbar({ 
                open: true, 
                message: 'No QR Code data available', 
                severity: 'warning' 
            });
            return;
        }

        try {
            const qrImageSrc = getQrImageSrc();
            if (qrImageSrc) {
                const imgLink = document.createElement('a');
                imgLink.href = qrImageSrc;
                imgLink.setAttribute('download', `einvoice-qr-${qrCodeData}.png`);
                document.body.appendChild(imgLink);
                imgLink.click();
                imgLink.parentNode.removeChild(imgLink);
                setSnackbar({ open: true, message: "QR Code downloaded successfully", severity: "success" });
                return;
            }

            const qrCanvas = document.querySelector('canvas');
            
            if (!qrCanvas) {
                setSnackbar({ 
                    open: true, 
                    message: 'QR Code canvas not found. Please generate QR code first.', 
                    severity: 'warning' 
                });
                return;
            }

            qrCanvas.toBlob((blob) => {
                if (!blob) {
                    setSnackbar({ 
                        open: true, 
                        message: 'Failed to convert QR code to image', 
                        severity: 'error' 
                    });
                    return;
                }

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `einvoice-qr-${qrCodeData}.png`);
                
                document.body.appendChild(link);
                link.click();
                
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);

                setSnackbar({ 
                    open: true, 
                    message: "QR Code downloaded successfully", 
                    severity: "success" 
                });
            }, 'image/png');

        } catch (error) {
            console.error("Download error:", error);
            setSnackbar({ 
                open: true, 
                message: `Failed to download QR Code: ${error.message}`, 
                severity: "error" 
            });
        }
    };

    /* ================= UI ================= */
    return (
        <Box sx={{ bgcolor: 'white', p: 1.5, fontFamily: 'Arial, sans-serif' }}>
            <Paper
                elevation={0}
                sx={{
                    border: '1px solid #ccc',
                    maxWidth: 1200,
                    mx: 'auto',
                    overflow: 'hidden',
                    bgcolor: '#fffef5',
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', flexWrap: 'wrap' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isServiceBill}
                                        onChange={(e) => setIsServiceBill(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="IsService Bill?"
                                sx={{ minWidth: 180, m: 0 }}
                            />
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={isEwayBillRequired}
                                        onChange={(e) => setIsEwayBillRequired(e.target.checked)}
                                        color="primary"
                                    />
                                }
                                label="Is EwayBill Required?"
                                sx={{ minWidth: 180, m: 0 }}
                            />
                            <FormControl size="small" sx={{ minWidth: 160 }}>
                                <InputLabel id="einvoice-server-label">Server</InputLabel>
                                <Select
                                    labelId="einvoice-server-label"
                                    label="Server"
                                    value={einvoiceServer}
                                    onChange={(e) => setEinvoiceServer(e.target.value)}
                                >
                                    <MenuItem value="Primary">Primary</MenuItem>
                                    <MenuItem value="Backup1">Backup1</MenuItem>
                                    <MenuItem value="Backup2">Backup2</MenuItem>
                                </Select>
                            </FormControl>
                        </Box>

                        <Box sx={{ mt: 2.5 }}>

                            <Typography variant="subtitle2" sx={{ fontSize: '0.9rem', mb: 1, fontWeight: 600 }}>
                                E-Invoice IRN / Response Details
                            </Typography>

                            <Box sx={{ position: 'relative', mb: 2 }}>
                                {renderTextField(
                                    einvoiceError ? `Error: ${einvoiceError}` : 'E-Invoice IRN / Response',
                                    'einvoiceNo',
                                    false,
                                    true,
                                    true
                                )}
                                {einvoiceError && (
                                    <Typography variant="caption" sx={{ color: '#d32f2f', mt: 0.5, display: 'block' }}>
                                        {einvoiceError}
                                    </Typography>
                                )}
                            </Box>

                            {submitError && (
                                <Alert severity="error" sx={{ mt: 2, whiteSpace: 'pre-wrap', color: '#d32f2f' }}>
                                    {submitError}
                                </Alert>
                            )}

                            <Box sx={{ mt: 3 }}>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        gap: 2,
                                        flexWrap: 'wrap'
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="medium"
                                        onClick={handleSubmit}
                                        disabled={
                                            einvoiceLoading ||
                                            einvoiceSuccess ||
                                            Object.keys(vehicleValidationErrors).length > 0 ||
                                            specValidationIssues.length > 0
                                        }
                                        sx={{
                                            minWidth: 180,
                                            fontWeight: 600
                                        }}
                                    >
                                        {einvoiceLoading ? (
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                <CircularProgress size={18} color="inherit" />
                                                Generating...
                                            </Box>
                                    ) : (
                                            'Generate E-Invoice'
                                        )}
                                    </Button>

                                    {qrCodeData && (
                                        <Button
                                            variant="contained"
                                            color="success"
                                            size="medium"
                                            startIcon={<GetApp />}
                                            onClick={handleDownload}
                                            sx={{ minWidth: 180, fontWeight: 600 }}
                                        >
                                            Download QR Code
                                        </Button>
                                    )}
                                </Box>

                                {/* ================= QR CODE PREVIEW ================= */}
                                {qrCodeData && (
                                    <Paper
                                        elevation={3}
                                        sx={{
                                            mt: 4,
                                            p: 3,
                                            maxWidth: 360,
                                            mx: 'auto',
                                            textAlign: 'center',
                                            borderRadius: 3,
                                            bgcolor: '#ffffff'
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{ fontWeight: 600, mb: 2 }}
                                        >
                                            E-Invoice QR Code
                                        </Typography>

                                        <Box
                                            sx={{
                                                p: 2,
                                                border: '1px solid #e0e0e0',
                                                borderRadius: 2,
                                                bgcolor: '#fafafa',
                                                display: 'inline-block'
                                            }}
                                        >
                                            {getQrImageSrc() ? (
                                                <img
                                                    src={getQrImageSrc()}
                                                    alt="E-Invoice QR Code"
                                                    style={{ width: 220, height: 220, display: 'block' }}
                                                />
                                            ) : (
                                                /* ✅ CORRECT COMPONENT (signed QR token / IRN fallback) */
                                                <QRCodeCanvas
                                                    value={String(einvoiceResponse?.data?.signedQRCode || qrCodeData)}
                                                    size={220}
                                                    level="L"
                                                    includeMargin={true}
                                                />
                                            )}
                                        </Box>
                                    </Paper>
                                )}

                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Paper>

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={() => setSnackbar(p => ({ ...p, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            {submitError && (
                <Alert severity="error" sx={{ mt: 1.5, maxWidth: 1200, mx: 'auto' }}>
                    {submitError}
                </Alert>
            )}
        </Box>
    );
};

export default EInvoiceMaster;